/**
 * Ingles. La clave es el texto en español tal cual aparece en el codigo.
 *
 * Las frases de fin de partido (`matchChrome`) NO se traducen literalmente:
 * son chascarrillos y lo que hay que conservar es la gracia, no las palabras.
 * Una traduccion palabra por palabra de "el cesped todavia vibra" no dice nada
 * en ingles.
 *
 * Ojo con lo que NO esta aqui a proposito: `?sala=` es una clave de URL, no
 * texto. Traducirla romperia todos los enlaces de invitacion ya compartidos.
 */
export const EN: Record<string, string> = {
  "Juegas como invitado y tu carrera <strong>ya se guarda sola</strong>. Conecta Google si quieres recuperarla en otro móvil u otro ordenador.":
    "You're playing as a guest and your career <strong>already saves itself</strong>. Connect Google if you want it back on another phone or computer.",

  // --- Ficha del jugador: atributos, media y nivel
  "REMATE": "FINISH",
  "Goles y puntería": "Goals and accuracy",
  "VISIÓN": "VISION",
  "Asistencias": "Assists",
  "PASE": "PASSING",
  "Pases que llegan": "Passes that land",
  "ROBO": "STEALS",
  "Balones recuperados": "Balls won back",
  "CONTROL": "CONTROL",
  "Balones que no pierdes": "Balls you don't lose",
  "DECISIVO": "CLUTCH",
  "Victorias y MVP": "Wins and MVPs",
  "Atributos": "Attributes",
  "MEDIA": "OVERALL",
  "NIVEL {n}": "LEVEL {n}",
  "¡NIVEL {n}!": "LEVEL {n}!",
  "{a} / {b} XP para el nivel {n}": "{a} / {b} XP to level {n}",
  "{a}/{b} para el nivel {n}": "{a}/{b} to level {n}",
  "Media provisional: te faltan {n} partidos para que sea del todo tuya.":
    "Provisional rating: {n} more matches and it's fully yours.",
  "Tu punto débil ahora mismo: {a}.": "Your weak spot right now: {a}.",
  "Forma": "Form",
  "sin datos": "no data yet",
  "En caída": "Slipping",
  "Irregular": "Patchy",
  "Estable": "Steady",
  "En alza": "Rising",

  // Arquetipos. Se conserva la chispa, no la palabra: "MURO" es una imagen, no
  // una pared, y "THE WALL" es la que se usa en ingles para lo mismo.
  "KILLER": "KILLER",
  "Si la ve, la mete": "Sees it, buries it",
  "MAESTRO": "MAESTRO",
  "El pase que nadie ve": "The pass nobody sees",
  "METRÓNOMO": "METRONOME",
  "El equipo pasa por ti": "The team runs through you",
  "MURO": "THE WALL",
  "Por ahí no se pasa": "Nobody gets past",
  "IMÁN": "MAGNET",
  "El balón no se te va": "The ball sticks to you",
  "LÍDER": "LEADER",
  "Contigo se gana": "You make teams win",

  // Divisiones
  "LEYENDA": "LEGEND",
  "CLASE MUNDIAL": "WORLD CLASS",
  "ÉLITE": "ELITE",
  "PROFESIONAL": "PRO",
  "SEMIPRO": "SEMI-PRO",
  "AMATEUR": "AMATEUR",

  // --- Insignias y escalones
  "Sin empezar": "Not started",
  "Bronce": "Bronze",
  "Plata": "Silver",
  "Oro": "Gold",
  "Leyenda": "Legend",
  "Goleador": "Scorer",
  "Goles marcados": "Goals scored",
  "Asistente": "Provider",
  "Asistencias repartidas": "Assists given",
  "Recuperador": "Ball winner",
  "Balones robados": "Balls stolen",
  "Metrónomo": "Metronome",
  "Pases completados": "Completed passes",
  "Estrella": "Star",
  "Veces MVP del partido": "Times player of the match",
  "Ganador": "Winner",
  "Partidos ganados": "Matches won",
  "Partidos jugados": "Matches played",
  "Cerrojo": "Lockdown",
  "Partidos sin encajar": "Clean sheets",
  "Francotirador": "Sniper",
  "Tiros a puerta": "Shots taken",
  "Fiel": "Regular",
  "Racha de días seguidos": "Day streak",

  // --- Trofeos: rareza y los nuevos
  "Común": "Common",
  "Poco común": "Uncommon",
  "Épico": "Epic",
  "Legendario": "Legendary",
  "Ladrón": "Thief",
  "Póker": "Four-goal haul",
  "Cuatro goles en un mismo partido": "Four goals in a single match",
  "Doble-doble": "Double-double",
  "Dos goles y dos asistencias en el mismo partido": "Two goals and two assists in one match",
  "Camarero": "The waiter",
  "Tres asistencias en un mismo partido": "Three assists in a single match",
  "Gol de oro": "Golden goal",
  "Marca el gol que acaba el partido en muerte súbita": "Score the goal that ends a sudden-death match",
  "Impecable": "Flawless",
  "Acaba un partido sin perder un solo balón": "Finish a match without losing a single ball",
  "El único que se salvó": "The only one who showed up",
  "Sé MVP en un partido que perdiste": "Be player of the match in a defeat",
  "Resurrección": "Resurrection",
  "Gana un partido en el que ibas dos goles por debajo": "Win a match after going two goals down",
  "Intocable": "Untouchable",
  "Gana siete partidos seguidos": "Win seven matches in a row",
  "Titular": "Starter",
  "Alcanza una media de 70": "Reach a 70 overall",
  "Franquicia": "Franchise player",
  "Alcanza una media de 80": "Reach an 80 overall",
  "Balón de oro": "Ballon d'Or",
  "Alcanza una media de 90": "Reach a 90 overall",
  "Profesional": "Turning pro",
  "Llega al nivel 10": "Reach level 10",
  "Carrera hecha": "A career made",
  "Llega al nivel 25": "Reach level 25",
  "Semana redonda": "Perfect week",
  "Suma 30 puntos en una misma semana": "Score 30 points in a single week",
  "Manita": "Five-nil",
  "Gana un partido por cinco goles de diferencia": "Win a match by five goals",

  // --- Pantalla de estadisticas
  "FICHA": "PLAYER",
  "HISTORIAL": "HISTORY",
  "LOGROS": "AWARDS",
  "RÉCORDS": "RECORDS",
  "Compartir mi ficha": "Share my card",
  "Historial": "History",
  "Se guardan tus últimos 25 partidos.": "Your last 25 matches are kept.",
  "Insignias": "Badges",
  "Trofeos": "Trophies",
  "Tu mejor versión": "Your best ever",
  "Cómo ha ido tu media": "How your rating has moved",
  "Juega unos cuantos partidos y aquí se dibujará tu curva.":
    "Play a few matches and your curve will show up here.",
  "Aquí aparecerá cada partido que juegues, con tu ficha entera. Todavía no hay ninguno.":
    "Every match you play will show up here with your full stat line. None yet.",
  "{n} partidos": "{n} matches",
  "Últimos {n} partidos": "Last {n} matches",
  "{v} · al máximo": "{v} · maxed out",
  "{v} / {n}": "{v} / {n}",
  "Efectividad": "Conversion",
  "Pases": "Passes",
  "Acierto": "Accuracy",
  "Pérdidas": "Losses",
  "Duración": "Length",
  "Media": "Rating",
  "Goles en un partido": "Goals in a match",
  "Asistencias en un partido": "Assists in a match",
  "Robos en un partido": "Steals in a match",
  "Mejor puntuación": "Best match score",
  "Mayor goleada": "Biggest win",
  "Gol más rápido": "Fastest goal",
  "Mejor racha": "Best streak",
  "victorias seguidas": "wins in a row",
  "Mejor semana": "Best week",
  "Días seguidos": "Day streak",
  "Mejor media": "Best rating",
  "Victorias": "Win rate",
  "Goles por partido": "Goals per match",
  "Tiempo jugado": "Time played",
  "Conectado como {email}": "Signed in as {email}",
  "Apunta esto: {code}": "Write this down: {code}",
  "¡Récord personal!": "Personal record!",
  "({n} batidos)": "({n} broken)",
  "Lo que te llevas": "What you take home",
  "PARTIDOS": "MATCHES",
  "ASIST.": "ASSISTS",
  "Tu ficha": "Your player card",
  "Mi ficha en FYNTA. fynta.io": "My FYNTA player card. fynta.io",
  "Guardada": "Saved",
  // --- HUD y partido
  "EN DIRECTO": "LIVE",
  "FUERA DE JUEGO": "OFFSIDE",
  "EL LINIER LEVANTA": "FLAG IS UP",
  "VAR · REVISANDO": "VAR · CHECKING",
  "POSICIÓN ILEGAL ·": "OFFSIDE POSITION ·",
  "GOL ·": "GOAL ·",
  "LOCAL": "HOME",
  "VISITANTE": "AWAY",
  "¡GOLAZO!": "GOLAZO!",
  "¡GOLAZO TOTAL!": "ABSOLUTE GOLAZO!",
  "Gol": "Goal",
  "GOLES": "GOALS",
  "goles": "goals",
  "En propia": "Own goal",
  "Asistencia de": "Assist by",
  "Desvío de": "Deflected by",
  "MVP DEL PARTIDO": "PLAYER OF THE MATCH",
  "Menú": "Menu",
  "Volver al menú (Esc)": "Back to menu (Esc)",
  "Pantalla completa": "Full screen",
  "Ajustes de la sala": "Room settings",
  "Partido": "Match",
  "Reglas": "Rules",
  "Tiempos": "Periods",
  "Número de tiempos": "Number of periods",
  "Si acaban empatados": "If it ends level",
  "DESCANSO": "HALF-TIME",
  "Duración de cada tiempo": "Length of each period",
  "{p} x {m} min · {total} min de juego": "{p} x {m} min · {total} min total",
  "bot": "bot",
  "bots": "bots",
  "acaba de empezar": "just kicked off",
  "va por el minuto {n}": "{n} min in",
  "Aparece sobre tu jugador y en las estadísticas del partido. Máximo 12 caracteres.": "Shown above your player and in the match stats. 12 characters max.",
  "Duración del partido": "Match length",
  "Menos minutos": "Fewer minutes",
  "Más minutos": "More minutes",
  "Minutos de partido": "Match minutes",
  "Duraciones rápidas": "Quick lengths",
  "min": "min",
  "Cámara: {mode}": "Camera: {mode}",
  "cola": "queue",
  "Salir de pantalla completa": "Exit full screen",

  // --- Menu principal
  "MÚSICA · ON": "MUSIC · ON",
  "MÚSICA · OFF": "MUSIC · OFF",

  // --- Online
  "EN LÍNEA": "ONLINE",
  "SIN CONEXIÓN": "OFFLINE",
  "Sin conexión con el servidor": "No connection to the server",
  "Con amigos": "With friends",
  "Sala": "Room",
  "Sala privada": "Private room",
  "Contraseña de la sala": "Room password",
  "Contraseña requerida": "Password required",
  "Creando la sala…": "Creating the room…",
  "Jugar (vs bots)": "Play (vs bots)",
  "Ponerte en": "Move to",
  "Entrar en": "Join",
  "Empieza en": "Starts in",
  "Termina en": "Ends in",
  "jugadores": "players",
  "pública": "public",
  "por enlace": "invite only",
  "La jornada": "This week",
  "La jornada · EN JUEGO": "This week · LIVE",
  "partido avanzado · ya no se puede entrar": "match in progress · can't join now",
  "s con bots": "s with bots",
  "· empieza en": "· starts in",
  "· entras como bot libre": "· you take a free bot slot",
  "Cópialo tú": "Copy it yourself",
  "¡Copiado!": "Copied!",
  "Jugador": "Player",

  // --- Estado de la partida
  "Conexión perdida": "Connection lost",
  "Esperando reconexión con el servidor…": "Waiting to reconnect to the server…",
  "Partida abandonada": "Match abandoned",
  "Partida desincronizada": "Match out of sync",
  "No queda nadie conectado en la sala.": "Nobody is left in the room.",
  "Los jugadores han dejado de ver el mismo partido. Hay que volver al menú.":
    "Players stopped seeing the same match. Back to the menu.",
  "Cuenta conectada. Ya no la pierdes.": "Account linked. You won't lose it now.",
  "Listo. Ahora juegas como": "Done. You're now playing as",
  "Conectado como": "Signed in as",

  // --- Movil
  "Gira el dispositivo": "Rotate your device",

  // --- Personalizar
  "Personalizar": "Customise",
  "Personalizar partido": "Customise match",
  "jugador": "player",
  "Pase corto, bloque medio y paciencia. El balon es tuyo.":
    "Short passing, mid block, patience. The ball is yours.",
  "Presion alta y campo ancho. Les quitas el aire en su area.":
    "High press, wide pitch. You suffocate them in their own box.",
  "Bloque bajo y salida a la contra. Que vengan ellos.":
    "Low block, counter-attack. Let them come to you.",
  "En cuanto la recuperas, va para arriba. Menos toque, mas riesgo.":
    "Win it, send it forward. Less passing, more risk.",

  // --- Carrera
  "día": "day",
  "días seguidos": "day streak",
  "se reinicia en": "resets in",
  "pts esta semana": "pts this week",

  // --- Logros
  "El primero": "First one",
  "Marca tu primer gol": "Score your first goal",
  "El último pase": "The final pass",
  "Reparte tu primera asistencia": "Get your first assist",
  "El mejor": "The best",
  "Sé MVP de un partido": "Be player of the match",
  "Portería a cero": "Clean sheet",
  "Gana sin encajar": "Win without conceding",
  "En racha": "On a run",
  "Juega tres días seguidos": "Play three days in a row",
  "Director de juego": "Playmaker",
  "Dos asistencias en un mismo partido": "Two assists in one match",
  "Dos goles en un mismo partido": "Two goals in one match",
  "Tres goles en un mismo partido": "Three goals in one match",
  "En el descuento": "Stoppage time",
  "Marca en el último minuto": "Score in the last minute",
  "Marca en los primeros 30 segundos": "Score in the first 30 seconds",
  "Juega veinticinco partidos": "Play twenty-five matches",
  "Sé MVP en cinco partidos": "Be player of the match five times",
  "Roba diez balones en un partido": "Win the ball ten times in one match",

  // --- Resumen del partido
  "el gol del partido": "the goal of the match",
  "el mas constante": "the most consistent",
  "gol y asistencia": "a goal and an assist",
  "la asistencia": "the assist",

  // --- Tarjeta de resultado
  "Tarjeta del resultado": "Result card",
  "¡Copiada!": "Copied!",
  "sin imagen": "no image",

  // --- Titulares de fin de partido: se busca el TONO, no la literalidad.
  "historia en vivo": "live history",
  "breaking césped": "breaking turf",
  "alerta de leyenda": "legend alert",
  "sin filtros": "no filters",
  "tablas de guerra": "battle drawn",
  "empate con sangre": "a bloody draw",
  "punto y aparte": "full stop",
  "modo phoenix": "phoenix mode",
  "capítulo unfinished": "unfinished chapter",
  "EL RIVAL FIRMÓ": "THEY SIGNED IT",
  "NADIE SE RINDIÓ": "NOBODY BLINKED",
  "ESTO ES CINE": "THIS IS CINEMA",
  "DOMINIO ABSOLUTO": "TOTAL CONTROL",
  "NO HUBO DUELO": "THAT WAS NO CONTEST",
  "TE HAN BAILADO": "THEY DANCED ON YOU",
  "NOCHE NEGRA": "DARK NIGHT",
  "TE HAN COMIDO VIVO": "EATEN ALIVE",
  "MISMA HAMBRE": "SAME HUNGER",
  "TABLAS INCENDIARIAS": "A DRAW ON FIRE",
  // --- Resumen de final de partido
  "TU PARTIDO": "YOUR MATCH",
  "PASA ATRÁS": "PASS IT BACK",
  "{n} balones robados": "{n} balls won back",
  "GOL": "G",
  "ASI": "A",
  "TIR": "SH",
  "REC": "REC",
  "El rival vino a pelear. Se fue a pedir autógrafos.":
    "They came to fight. They left asking for autographs.",
  "Hubo coronación. El marcador es solo la prueba forense.":
    "That was a coronation. The scoreline is just the evidence.",
  "El césped todavía vibra. Guarda esto: acabas de firmar un clip eterno.":
    "The turf is still humming. Save this one — you just made a forever clip.",
  "No jugaste un partido. Rodaste una película con balón.":
    "You didn't play a match. You shot a film with a ball in it.",
  "Duele. Sirve. La revancha ya está escribiendo tu nombre.":
    "It stings. It teaches. The rematch is already writing your name.",
  "Hoy el césped no te sonrió. Mañana le sacas los dientes.":
    "The pitch didn't smile at you today. Tomorrow you make it grin.",
  "Aplaude al rival… y luego cómetelo en la vuelta.":
    "Clap for them… then eat them alive in the return leg.",
  "El marcador empató. El orgullo, jamás.":
    "The scoreboard drew. Pride never does.",
  "No hubo ganador. Hubo espectáculo. Eso también es victoria.":
    "No winner. Just a show. That counts as a win too.",
  "Tú pusiste el alma. Ellos pusieron el marcador. Empate emocional.":
    "You brought the soul. They brought the scoreline. Emotionally, a draw.",
  "Dos equipos. Cero concesiones. Un final que pide bis.":
    "Two teams. Zero mercy. An ending that begs for an encore.",

  "Idioma": "Language",


  // --- Descripciones de modo (viven en shared; se traducen al pintarlas)
  "Duelo con porteros. Uno contra uno, y a la escuadra.":
    "Keepers on. One on one, top corner.",
  "Portero, un ancla y una punta. Paredes y espacio.":
    "Keeper, an anchor and a striker. Give-and-go and space.",
  "Portero y 1-2. Ataque directo, defensa corta.":
    "Keeper and 1-2. Direct attack, short defence.",
  "Futbol sala exacto: diamante 1-2-1 con portero.":
    "Proper futsal: 1-2-1 diamond with a keeper.",
  "Portero y 2-2-1. El escalon entre la sala y el futbol 7.":
    "Keeper and 2-2-1. The step between futsal and 7-a-side.",
  "Futbol 7 exacto: 2-3-1 con portero. Mas espacio real.":
    "Proper 7-a-side: 2-3-1 with a keeper. Real space at last.",
  "Portero y 3-3-1. Ya se juega por dentro y por fuera.":
    "Keeper and 3-3-1. Now you play inside and out.",
  "Portero y 3-3-2. Dos puntas y campo de verdad.":
    "Keeper and 3-3-2. Two strikers and a proper pitch.",
  "Portero y 4-3-2. Casi el partido completo.":
    "Keeper and 4-3-2. Almost the full game.",
  "Partido completo a medio gas. Posicion y paciencia.":
    "The full game at half throttle. Position and patience.",
  "ritmo": "pace",

  // --- Menu principal (tarjetas)
  "SALAS": "ROOMS",
  "PRIVADO LOCAL / IA": "LOCAL / VS AI",
  "MIS ESTADÍSTICAS": "MY STATISTICS",
  "Multijugador online · Salas de espera · Bots en huecos vacíos":
    "Online multiplayer · Waiting rooms · Bots fill empty slots",
  "Contra la IA": "Vs AI",
  "En 2v2 cada equipo tiene un solo jugador de campo": "In 2v2 each team has a single outfield player",
  "Jugador 1": "Player 1",
  "Jugador 2": "Player 2",
  "Espacio": "Space",
  "izq.": "left",
  "der.": "right",
  "o un mando cada uno": "or one controller each",
  "Los dos en el mismo equipo contra la IA.": "Both on the same team against the AI.",
  "Tú y tu equipo contra la IA.": "You and your team against the AI.",
  "Uno contra otro, cada uno con su equipo de IA.": "Head to head, each with an AI team.",
  "Partido Local · Vs. IA o 2 Jugadores · Juega a tu ritmo":
    "Local match · Vs AI or 2 players · At your own pace",
  "Tu carrera": "Your career",
  "Sin conexión": "Offline",
  // "Enter entrar" en español; en ingles "Enter enter" queda redundante.
  "entrar": "select",
  "moverse": "move",

  // --- Menu de partido
  "elige tu partido": "choose your match",
  "Modo": "Mode",
  "Modo de juego": "Game mode",
  "Seleccionar modo": "Select mode",
  "Jugar": "Play",
  "jugar": "play",
  "modo": "mode",
  "volver": "back",
  "Menú principal": "Main menu",
  "Salir al menú": "Back to menu",
  "← Menú": "← Menu",

  // --- Lobby
  "Salas": "Rooms",
  "rápida": "quick",
  "Modo de partida rápida": "Quick match mode",
  "Actualizar salas": "Refresh rooms",
  "No hay salas abiertas": "No open rooms",
  "Crea una sala y pulsa": "Create a room and hit",
  ": los huecos vacíos son bots. Quien entre ocupará un bot al azar.":
    ": empty slots are bots. Anyone who joins takes a random bot's place.",
  "Crear sala": "Create room",
  "+ Crear sala": "+ Create room",
  "👥 Jugar con amigos": "👥 Play with friends",
  "Nueva sala": "New room",
  "Configuración": "Settings",
  "Mi sala": "My room",
  "Pública": "Public",
  "Jugadores": "Players",
  "Las privadas piden contraseña al crear y al entrar.":
    "Private rooms ask for a password to create and to join.",
  "Contraseña": "Password",
  "Local": "Home",
  "Visitante": "Away",
  "Los porteros los lleva siempre la IA.": "Goalkeepers are always played by the AI.",
  "Huecos vacíos = bots. Al unirse, un jugador ocupa un bot al azar.":
    "Empty slots = bots. When someone joins, they take a random bot's place.",
  "Salir": "Leave",
  "Pásales este enlace": "Send them this link",
  "Solo entra quien tenga el enlace. No sale en ninguna lista.":
    "Only people with the link can join. It won't show up in any list.",
  "Tu nombre en partida": "Your in-game name",
  "en partida": "in game",

  // --- Personalizar
  "Partido local": "Local match",
  "Tu nombre": "Your name",
  "Sin nombre": "No name",
  "Aparece sobre tu jugador. Maximo 12 caracteres.":
    "Shown above your player. 12 characters max.",
  "Dorsal": "Number",
  "Numero de dorsal": "Shirt number",
  "Subir dorsal": "Number up",
  "Bajar dorsal": "Number down",
  "Sin arquetipo: juegas segun tu rol en el campo.":
    "No archetype: you play to your role on the pitch.",
  "Nivel de asistencia": "Assist level",
  "Estilo de cesped": "Pitch style",
  "Plan de equipo": "Team plan",
  "Preajustes de plan": "Plan presets",
  "Como juegan tus companeros. Son las mismas palancas que usa la IA.":
    "How your team-mates play. The same levers the AI uses.",

  // --- Carrera
  "Mis estadísticas": "My statistics",
  "Esta semana": "This week",
  "Últimos partidos": "Recent matches",
  "Con quién ganas": "Who you win with",
  "Aún no has jugado ningún partido. El primero es el que más pesa.":
    "You haven't played a match yet. The first one always counts most.",
  "Juega online y aquí saldrá con quién mejor te entiendes.":
    "Play online and this will show who you click with.",
  "Tu cuenta": "Your account",
  "Juegas como invitado y tu carrera": "You're playing as a guest and your career",
  "ya se guarda sola": "already saves itself",
  "Sacar mi código": "Get my code",
  "pegar código": "paste code",
  "o con un código, sin cuentas": "or with a code, no account needed",

  // --- Puerta de entrada
  "JUGAR COMO INVITADO": "PLAY AS GUEST",
  "Empiezas ahora. Puedes guardar la cuenta cuando quieras.":
    "Start now. You can save your account whenever you like.",
  "Tu carrera te sigue a cualquier móvil u ordenador.":
    "Your career follows you to any phone or computer.",
  "¿Cómo te llamas?": "What's your name?",
  "tu nombre": "your name",
  "¿Tienes un código?": "Got a code?",
  "‹ Volver": "‹ Back",

  // --- Marcador final
  "Final del partido": "Full time",
  "Resumen del partido": "Match summary",
  "Sin MVP": "No MVP",
  "Sin goles.": "No goals.",
  "Partido sin nada que destacar.": "Nothing much to report.",

  // --- Movil
  "Gira el móvil": "Rotate your phone",
  "FYNTA se juega en horizontal": "FYNTA is played in landscape",

  // --- Donaciones
  "Otras formas de apoyar": "Other ways to support",
  "Añade tu enlace en donations.ts": "Add your link in donations.ts",

  // --- Donaciones
  "Indie · Sin ads · Sin paywall": "Indie · No ads · No paywall",
  "☕ INVÍTAME A UN CAFÉ": "☕ BUY ME A COFFEE",
  "Hecho por una persona, sin ads ni paywall. Un café lo mantiene gratis.":
    "Made by one person, no ads, no paywall. A coffee keeps it free.",
  "Un segundo, antes del pitido inicial…": "One second, before kick-off…",
  "¿Te lo has pasado bien? No dejes que FYNTA se quede en el banquillo.":
    "Had fun? Don't leave FYNTA sitting on the bench.",
  "Proyecto hecho por una sola persona, sin inversores ni publicidad. Si disfrutaste del partido, un café mantiene el juego gratis para todos — y financia lo que viene.":
    "Built by one person, no investors, no advertising. If you enjoyed the match, a coffee keeps the game free for everyone — and funds what comes next.",
  "Cada apoyo suma. Tú eliges si esto sigue creciendo.":
    "Every bit helps. You decide whether this keeps growing.",
  "Información legal": "Legal information",
  "Privacidad": "Privacy",
  "Términos": "Terms",

  // --- Marcador y fin de partido
  "Jugador {n}": "Player {n}",
  "TÚ": "YOU",
  "eres tú": "that's you",
  "Goles": "Goals",
  "Tiros": "Shots",
  // Cabeceras de una letra de la tabla. En ingles Tiros es Shots: la inicial
  // cambia, y por eso son claves y no letras fijas en el HTML.
  "G": "G",
  "A": "A",
  "T": "S",
  "P": "P",
  "Victoria": "Win",
  "Derrota": "Loss",
  "Empate": "Draw",
  "Victoria local": "Home win",
  "Victoria visitante": "Away win",
  "¡Tu gol!": "Your goal!",
  "¡Tu asistencia!": "Your assist!",
  "Asistencia de {quien}": "Assisted by {quien}",
  "Sin ayuda de nadie": "All on your own",
  "La empujó {quien}": "{quien} tapped it in",
  "Desvío de {quien}": "Deflected by {quien}",
  "Se le mete solo": "Straight into their own net",
  "{goleador} · asistió {asistente}": "{goleador} · assist {asistente}",
  "Lo marcó {quien}": "Scored by {quien}",
  "{n} goles": "{n} goals",
  "{n} asistencias": "{n} assists",

  // --- Lobby online
  "CONECTANDO…": "CONNECTING…",
  "RECONECTANDO…": "RECONNECTING…",
  "EN OTRA PESTAÑA": "IN ANOTHER TAB",
  "RECARGA: VERSIÓN NUEVA": "RELOAD: NEW VERSION",
  // --- Retransmision: lo que decide la IA y consejos de la primera vez
  "Juegan: {style}": "They play: {style}",
  "TU EQUIPO": "YOUR TEAM",
  "Los tuyos se vuelcan": "Your side piles forward",
  "Aprietan arriba y van a por el gol.": "Pressing high and going for the goal.",
  "Se vuelcan al ataque": "They pile forward",
  "Arriesgan con todo: detrás dejan sitio para la contra.": "All in: there's room behind them for a counter.",
  "Los tuyos cierran el partido": "Your side shuts up shop",
  "Bloque bajo y sin prisa: toca aguantar.": "Deep block, no rush: time to hold on.",
  "Se encierran atrás": "They park the bus",
  "Cierran el partido y su portero se toma su tiempo.": "Game management, and their keeper is in no hurry.",
  "«Correr»": "“Sprint”",
  "CONSEJO": "TIP",
  "Te han embestido": "You got barged",
  "Pulsa {key} justo antes del choque para plantarte: rebota él y el balón sigue siendo tuyo.":
    "Press {key} just before the hit to brace: they bounce off and the ball stays yours.",
  "¡Te has plantado!": "You braced!",
  "Así se aguanta un balón: {key} justo antes del choque, y rebota el que embiste.":
    "That's how you hold the ball: {key} just before the hit, and the charger bounces off.",
  "Se ha plantado": "They braced",
  "Te ha visto venir y has rebotado tú. Embiste cuando no te espere, no cuando te está mirando.":
    "They saw you coming and you bounced off. Charge when they don't expect it, not when they're watching.",
  "Recargar": "Reload",
  "Hay una versión nueva de FYNTA": "There's a new version of FYNTA",
  "Recarga la página para jugar online con los demás. Local / IA y la carrera siguen funcionando sin recargar.":
    "Reload the page to play online with everyone else. VS AI and the career keep working without reloading.",
  "Jugar aquí": "Play here",
  "Abierto en otra pestaña": "Open in another tab",
  "Seguir sin conexión": "Stay offline",
  "Tu cuenta se está usando en otra pestaña o en otro dispositivo, y la conexión se ha quedado allí. Pulsa «Jugar aquí» para traerla.":
    "Your account is being used in another tab or on another device, and the connection stayed there. Tap “Play here” to bring it back.",
  "privada": "private",
  "Esperando host…": "Waiting for host…",
  "Sala {modo}": "{modo} room",
  "Entrar en {sala}": "Join {sala}",
  // "jug." es la abreviatura normal en español; en ingles "pl." no se lee,
  // asi que va la palabra entera y el chip se ajusta con el tamaño de letra.
  "{n} jug.": "{n} players",
  "Empieza en {gap}": "Starts in {gap}",
  "Termina en {gap}": "Ends in {gap}",
  "{d} d {h} h": "{d}d {h}h",
  "{h} h {m} min": "{h}h {m}m",
  "{m} min": "{m} min",

  // --- La jornada semanal (las reglas viven en shared y se traducen al pintar)
  "Jornada clásica": "Classic week",
  "5v5, sin florituras. El fútbol de siempre.": "5v5, no frills. Football as usual.",
  "Porterías pequeñas en 5v5. Cada gol se suda.": "Small goals in 5v5. Every goal is earned.",
  "Relámpago": "Lightning",
  "3v3 a partidos cortos. Sin tiempo para pensar.": "Short 3v3 matches. No time to think.",
  "Maratón": "Marathon",
  "7v7 largo. Gana quien aguante el bloque.": "Long 7v7. Whoever holds their shape wins.",
  "Duelo": "Duel",
  "2v2 corto y a cara de perro.": "Short 2v2, no quarter given.",

  // --- Carrera
  "Partidos": "Matches",
  "{g}G · {e}E · {p}P": "{g}W · {e}D · {p}L",
  "mejor racha {n}": "best streak {n}",
  "1 día seguido": "1 day in a row",
  "{n} días seguidos": "{n} days in a row",
  "{n} victorias seguidas": "{n} wins in a row",
  "{n} pts esta semana": "{n} pts this week",
  "se reinicia en 1 día": "resets in 1 day",
  "se reinicia en {n} días": "resets in {n} days",
  "Listo. Ahora juegas como {nick}.": "Done. You now play as {nick}.",

  // --- Logros
  "Doblete": "Brace",
  "Hat-trick": "Hat-trick",
  "Crack": "Star player",
  "Remontada": "Comeback",
  "Gana un partido que ibas perdiendo": "Win a match you were losing",
  "Madrugador": "Early bird",
  "Gana tres partidos seguidos": "Win three matches in a row",
  "Habitual": "Regular",
  "Veterano": "Veteran",

  // --- Modal de personalizar
  "Secciones": "Sections",
  "Cancha": "Pitch",
  "Plan": "Plan",
  "Ayuda": "Assist",
  "Cerrar": "Close",
  "Dorsales rápidos": "Quick numbers",
  "Apodo": "Nickname",
  "Césped": "Grass",
  "Asistencia": "Assist level",
  "Restablecer": "Reset",
  "Listo": "Done",

  // --- Equipaciones. Los nombres son COMBINACIONES DE COLOR, no clubes, asi
  // que se traducen como tales: "Verdiblanco" es "Green & White".
  "Equipo": "Team",
  "Tu equipo": "Your team",
  "Rival": "Opponent",
  "Nombre de tu equipo": "Your team name",
  "Nombre del rival": "Opponent name",
  "El nombre sale en los goles, en el acta y en el resumen.":
    "The name shows up on goals, in the stats and in the summary.",
  "Tu equipación": "Your kit",
  "Equipación de tu equipo": "Your team kit",
  "Equipación del rival": "Opponent kit",
  "Equipaciones": "Kits",
  "Qué equipación estás eligiendo": "Which kit you are choosing",
  "La tuya": "Yours",
  "La del rival": "Theirs",
  "vs": "vs",
  "El rival cambia de camiseta solo para no confundirse con la tuya.":
    "The opponent switches kit on its own so the two never clash.",
  "Equipación del rival fijada a mano.": "Opponent kit set by hand.",
  "El dorsal es solo aspecto: ningún número juega mejor que otro.":
    "The number is looks only: no shirt plays better than another.",
  "Patrón de la camiseta": "Shirt pattern",
  "Principal": "Main",
  "Segundo": "Second",
  "Detalle": "Trim",
  "A medida": "Custom",
  "Automática": "Automatic",
  "{home} de {homeKit} · {away} de {awayKit}.": "{home} in {homeKit} · {away} in {awayKit}.",
  "Lisa": "Plain",
  "Rayas": "Stripes",
  "Mitades": "Halves",
  "Banda": "Sash",
  "Aros": "Hoops",
  "Carmesí": "Crimson",
  "Ultramar": "Ultramarine",
  "Verdiblanco": "Green & White",
  "Grana y Azul": "Garnet & Blue",
  "Rojiblanco": "Red & White",
  "Rojinegro": "Red & Black",
  "Blanquinegro": "Black & White",
  "Blanco y Oro": "White & Gold",
  "Negro y Oro": "Black & Gold",
  "Amarillo y Negro": "Yellow & Black",
  "Celeste": "Sky Blue",
  "Naranja Total": "Total Orange",
  "Banda Roja": "Red Sash",
  "Aros Verdes": "Green Hoops",
  "Violeta": "Violet",
  "Granate": "Maroon",

  // --- Arquetipos de dorsal (viven en shared, se traducen al pintarlos).
  // Los nombres propios no se tocan: CR7 es CR7 en todos los idiomas.
  "Portero": "Goalkeeper",
  "Reflejos y colocacion. Cubre la meta como nadie.": "Reflexes and positioning. Nobody covers the goal better.",
  "Carrilero": "Wing-back",
  "Banda, overlap y centro. Sube y vuelve.": "Touchline, overlap, cross. Up and back all game.",
  "Defensa": "Defender",
  "Lectura y bloqueo. Ultimo hombre sin drama.": "Reads the game and blocks. Last man, no drama.",
  "Pivote: recupera, circula y nunca se quema.": "Holding mid: wins it back, moves it on, never rushed.",
  "Remate, timing y ambicion. Si hay hueco, dispara.": "Finishing, timing, ambition. Sees a gap, shoots.",
  "9 puro: espaldas al gol, velocidad y definicion.": "Out-and-out nine: back to goal, pace and finishing.",
  "Vision, pase filtrado y regate. El 10 manda.": "Vision, through balls, dribbling. The ten runs it.",
  "Regate, audacia y pase creativo. Impredecible.": "Dribbling, nerve and creative passing. Unpredictable.",

  // --- Puerta de entrada y carrera
  "EMPEZAR": "START",
  "Usar": "Use",
  "Logros": "Achievements",
  "puntos": "points",

  // --- Lobby: crear sala y salas
  "Nombre": "Name",
  "Visibilidad": "Visibility",
  "Privada": "Private",
  "Cancelar": "Cancel",
  "Confirmar": "Confirm",
  "Copiar": "Copy",
  "tuya": "yours",
  "cerrada": "closed",

  // --- Fin de partido
  "Revancha": "Rematch",
  "Continuar": "Continue",
  "Repetir": "Replay",
  "Recuperaciones": "Recoveries",
  "R": "R",
  "G goles · A asistencias · T tiros · P pases · R recuperaciones": "G goals · A assists · S shots · P passes · R recoveries",
  "Copiar imagen": "Copy image",
  "Guardar PNG": "Save PNG",
  "Usa Guardar PNG": "Use Save PNG",
  "Apoyar FYNTA": "Support FYNTA",

  // --- Datos que viven en shared y se traducen al pintarlos
  // Niveles de asistencia
  "Facil": "Easy",
  "Golpeo limpio aunque cruces la carrera. Ideal para entrar.":
    "Clean strike even off balance. The way in.",
  "Normal": "Normal",
  "Te perdona algo el cuerpo mal puesto. Apuntas tu.":
    "Forgives a bad body shape. You still aim.",
  "Pro": "Pro",
  "Cero perdon. Cambio manual. El techo de skill.":
    "No mercy. Manual switching. The skill ceiling.",

  // Estilos de cesped
  "Focos Nocturnos": "Night Lights",
  "Cesped clasico bajo focos dorados. El padron de Golazo.":
    "Classic turf under golden floodlights. The house pattern.",
  "Red Neón": "Neon Grid",
  "Hexagonos cyber sobre cesped de noche electrica.":
    "Cyber hexagons on electric night grass.",
  "Sol Central": "Centre Sun",
  "Rayos desde el circulo central. Campo de culto.":
    "Rays out of the centre circle. A cult pitch.",
  "Fútbol Sala": "Futsal",
  "Pista de sala con lineas reglamentarias FIFA y terrazo urbano.":
    "Indoor court with regulation FIFA lines and city terrazzo.",
  "Synthwave 88": "Synthwave 88",
  "Scanlines horizontales y cesped de otro universo.":
    "Horizontal scanlines and grass from another universe.",
  "Señales": "Signals",
  "Crop circles en el cesped. ¿Quien los hizo?":
    "Crop circles in the turf. Who made them?",
  "Espiga Real": "Royal Herringbone",
  "Patron herringbone como parquet de rey.":
    "Herringbone pattern like a king's parquet.",
  "Dos Mundos": "Two Worlds",
  "Mitad calida, mitad glacial. El campo se parte en dos.":
    "Half warm, half glacial. The pitch splits in two.",
  "Magma": "Magma",
  "Venas incandescentes bajo cesped volcánico.":
    "Glowing veins under volcanic turf.",
  "Cristal Polar": "Polar Glass",
  "Fragmentos de hielo sobre cesped artico.":
    "Shards of ice over arctic grass.",

  // Plan de equipo: nombres de preajuste y palancas
  "Control": "Control",
  "Vertical": "Direct",
  "Asfixia": "Suffocate",
  "Plan a medida.": "Custom plan.",
  "Mentalidad": "Mentality",
  "Replegado": "Deep",
  "Volcado": "All out",
  "Presion": "Pressing",
  "Esperar": "Sit off",
  "Asfixiar": "Smother",
  "Amplitud": "Width",
  "Estrecho": "Narrow",
  "Abierto": "Wide",
  "Ritmo": "Tempo",
  "Conducir": "Carry",
  "Tocar": "Pass",

  // --- Gol de oro
  "GOL DE ORO": "GOLDEN GOAL",
  "MUERTE SÚBITA": "SUDDEN DEATH",

  // --- Tabla final del partido
  "RESUMEN": "SUMMARY",
  "ESTADÍSTICAS": "SCOREBOARD",
  "Puntuación": "Score",
  "PTS": "PTS",
  "EFI": "EFF",
  "PAS": "PAS",
  "PER": "LOST",
  "Tiros que acabaron en gol": "Shots that became goals",
  "Balones perdidos": "Balls lost",

  // --- Compartir
  "Compartir": "Share",
  "Mira este golazo. fynta.io": "Check out this goal. fynta.io",
  "No se pudo compartir": "Couldn't share",
  "CÓMO SE JUEGA": "HOW TO PLAY",
  "moverte": "move",
  "golpear · toque pasa, mantener dispara": "kick · tap passes, hold shoots",
  "sprint": "sprint",
  "ver estadísticas": "match stats",
  "arrastra a la izquierda para moverte": "drag on the left to move",
  "ámbar: golpear · toque pasa, mantener dispara": "amber: kick · tap passes, hold shoots",
  "azul: correr": "blue: sprint",

  // --- Lobby online: pulso, filtros y campo de la sala
  "EN VIVO": "LIVE",
  "jugando": "playing",
  "conectados": "online",
  "salas": "rooms",
  "Buscar sala…": "Search rooms…",
  "Buscar sala por nombre": "Search rooms by name",
  "Filtros": "Filters",
  "Todas": "All",
  "Con hueco": "Open",
  "En partida": "Live",
  "Filtrar por modo": "Filter by mode",
  "Cualquier modo": "Any mode",
  "{modo} · {n} jug.": "{modo} · {n} players",
  "Ninguna sala encaja": "No room matches",
  "Hay {n} salas abiertas. Prueba a quitar filtros.":
    "There are {n} open rooms. Try clearing the filters.",
  "Campo": "Pitch",
  "Campo de la sala": "Room pitch",
  "Jugar ahora": "Play now",
  "JUGAR YA": "PLAY NOW",
  "Entrando…": "Dropping in…",
  "Entras al momento. Si no hay nadie juegas contra bots, y quien llegue se mete en tu partido.":
    "You are in straight away. Nobody around? You play the bots, and whoever shows up drops into your match.",

  // --- Sala: banquillo, mando del anfitrion y chat
  "Abrir": "Open",
  "Al banquillo": "To the bench",
  "Aún no ha escrito nadie. Saluda.": "Nobody has written yet. Say hi.",
  "Banquillo": "Bench",
  "Bot": "Bot",
  "Chat": "Chat",
  "Chat de la sala": "Room chat",
  "Denunciar a este jugador": "Report this player",
  "El anfitrión ha parado el partido": "The host stopped the match",
  "El anfitrión te ha pasado al banquillo": "The host moved you to the bench",
  "Enter": "Enter",
  "Entrar": "Join",
  "Enviar": "Send",
  "Eres el anfitrión: tú decides quién juega. Los huecos vacíos los lleva la IA.": "You're the host: you decide who plays. Empty slots are played by the AI.",
  "Escribe a la sala…": "Message the room…",
  "Escribe a la sala… (Esc para cerrar)": "Message the room… (Esc to close)",
  "Esperando al anfitrión…": "Waiting for the host…",
  "Expulsar de la sala": "Kick from the room",
  "IA": "AI",
  "L": "H",
  "MVP": "MVP",
  "Mensaje para la sala": "Message for the room",
  "Meter en Local": "Put in Home",
  "Meter en Visitante": "Put in Away",
  "Mostrar": "Show",
  "Mostrar los mensajes del chat": "Show chat messages",
  "Nadie esperando. Si la sala se llena, los que lleguen esperan aquí.": "Nobody waiting. If the room fills up, newcomers wait here.",
  "ONLINE": "ONLINE",
  "Ocultar": "Hide",
  "Ocultar los mensajes del chat": "Hide chat messages",
  "Parar partido": "Stop match",
  "Partido en juego · {min}": "Match in progress · {min}",
  "Partido en juego · {min}. Entras cuando el anfitrión te meta o al acabar.": "Match in progress · {min}. You're in when the host puts you in, or when it ends.",
  "Partido en juego · {min}. Juegas el siguiente: el anfitrión decide quién entra.": "Match in progress · {min}. You play the next one: the host decides who's in.",
  "Partido en juego · {min}. Puedes meter a alguien del banquillo o pararlo.": "Match in progress · {min}. You can bring someone in from the bench, or stop it.",
  "Partido en juego · {min}. Ya no se puede entrar: los del banquillo juegan el siguiente.": "Match in progress · {min}. It's too late to join: the bench plays the next one.",
  "Partido en juego…": "Match in progress…",
  "Ponerte en {equipo}, hueco {n}": "Move to {equipo}, slot {n}",
  "Pulsa un hueco libre para cambiarte. Los huecos vacíos los lleva la IA.": "Tap a free slot to switch. Empty slots are played by the AI.",
  "Salir de la sala": "Leave room",
  "Sentarme": "Take a seat",
  "Sienta a alguien para jugar": "Seat someone to play",
  "Te han expulsado de la sala": "You were kicked from the room",
  "Tu nombre ha quedado como {nick}": "Your name is now {nick}",
  "Unirse": "Join in",
  "V": "A",
  "Volver a la sala": "Back to the room",
  "anfitrión": "host",
  "anfitrión: {nick}": "host: {nick}",
  "en resultados": "on results",
  "entras como bot libre": "you take a free bot's place",
  "eres el anfitrión": "you're the host",
  "espera": "waiting",
  "humano": "human",
  "llena": "full",
  "partido avanzado · entras al banquillo": "match well under way · you join the bench",
  "sala llena": "room full",
  "tú": "you",
  "{nick} entra al partido": "{nick} joins the match",
  "{nick} es el nuevo anfitrión": "{nick} is the new host",
  "{nick} ha entrado en la sala": "{nick} joined the room",
  "{nick} ha parado el partido": "{nick} stopped the match",
  "{nick} ha sido expulsado": "{nick} was kicked",
  "{nick} pasa al banquillo": "{nick} moves to the bench",
  "{nick} se ha ido": "{nick} left",
  "{n} esperando": "{n} waiting",
  "Nadie en el banquillo": "Nobody on the bench",
  "El partido va muy avanzado: entran en el siguiente.": "The match is too far along: they join the next one.",
  "¿Seguro? Pulsa otra vez": "Sure? Tap again",

  // --- Lobby: amigos, chat del lobby y lista de salas
  "Aceptar": "Accept",
  "Amigos": "Friends",
  "Añadir": "Add",
  "Añadir amigo": "Add friend",
  "Cancelar solicitud": "Cancel request",
  "Conectado": "Online",
  "Código copiado: {code}": "Code copied: {code}",
  "Código de amigo": "Friend code",
  "Código de un amigo (XXXX-XXXX)": "A friend's code (XXXX-XXXX)",
  "En juego": "Playing",
  "En {sala} · {modo}": "In {sala} · {modo}",
  "Enviadas": "Sent",
  "Ese es tu propio código": "That's your own code",
  "Espera un poco antes de enviar más solicitudes": "Wait a bit before sending more requests",
  "Esperando": "Waiting",
  "Estado": "Status",
  "Habla con quien está en el lobby…": "Talk to whoever's in the lobby…",
  "Invitar a {nick}": "Invite {nick}",
  "Invitar amigos": "Invite friends",
  "Jugando en {sala}": "Playing in {sala}",
  "Jugar ya": "Play now",
  "Llena": "Full",
  "Límite de amigos alcanzado": "Friend limit reached",
  "Mensaje para el lobby": "Message for the lobby",
  "Nadie ha escrito todavía. Di qué quieres jugar y quedáis en una sala.": "Nobody has written yet. Say what you want to play and meet in a room.",
  "No hay nadie con ese código": "Nobody has that code",
  "Pásale tu código a alguien, o pulsa su nombre en el chat para añadirle.": "Share your code with someone, or tap their name in the chat to add them.",
  "Quitar de amigos": "Remove friend",
  "Rechazar": "Decline",
  "Solicitud enviada": "Request sent",
  "Solicitudes": "Requests",
  "Tu código de amigo": "Your friend code",
  "Ver": "View",
  "Ya se la habías pedido": "You already asked them",
  "Ya sois amigos": "You're already friends",
  "hace {n} días": "{n} days ago",
  "hace {n} h": "{n} h ago",
  "hace {n} min": "{n} min ago",
  "pendiente": "pending",
  "{nick} quiere ser tu amigo": "{nick} wants to be your friend",
  "{nick} te invita a {sala}": "{nick} invites you to {sala}",
  "{nick} te invita a {sala} ({modo})": "{nick} invites you to {sala} ({modo})",
  "{nick} y tú ya sois amigos": "You and {nick} are now friends",
  "¡Ya sois amigos!": "You're friends now!",
  "¿Quitar?": "Remove?",
  "Multijugador": "Multiplayer",
  "% V": "W %",
  "% victorias": "Win %",
  "AMIGOS": "FRIENDS",
  "Actualizar": "Refresh",
  "Asistencias por partido": "Assists per match",
  "Aún no habéis jugado en el mismo equipo.": "You haven't played on the same team yet.",
  "Aún no tienes amigos. Añádelos en Multijugador con su código, o pulsando su nombre en el chat.": "No friends yet. Add them in Multiplayer with their code, or by tapping their name in the chat.",
  "CONTRA LA IA": "VS AI",
  "Cargando su ficha…": "Loading their card…",
  "Cargando…": "Loading…",
  "Forma reciente": "Recent form",
  "Juntos": "Together",
  "La semana entre amigos": "The week among friends",
  "Nivel": "Level",
  "No se ha podido cargar. Comprueba la conexión.": "Couldn't load. Check your connection.",
  "PJ": "MP",
  "Pulsa en un amigo para ver su ficha comparada con la tuya.": "Tap a friend to see their card next to yours.",
  "Qué estadísticas": "Which stats",
  "Tú": "You",
  "Ver su ficha": "See their card",
  "{nick} aún no ha jugado online. Invítale a tu sala.": "{nick} hasn't played online yet. Invite them to your room.",
  "{p} partidos en el mismo equipo · {w} ganados ({pct}%)": "{p} matches on the same team · {w} won ({pct}%)",

  // --- Apodos unicos (2026-09-26)
  "Así te verán en las salas y en el chat. Es solo tuyo.": "This is how people see you in rooms and chat. It's yours alone.",
  "Cambiar": "Change",
  "Cambiar tu apodo": "Change your nickname",
  "Comprobando…": "Checking…",
  "ELIGE TU APODO": "CHOOSE YOUR NICKNAME",
  "Elige tu apodo": "Choose your nickname",
  "El servidor no contesta. Inténtalo de nuevo.": "The server isn't answering. Try again.",
  "Es el que ya tienes.": "That's the one you already have.",
  "Es único: nadie más puede llamarse igual. Mayúsculas, tildes y espacios no cuentan como diferencia.":
    "It's unique: nobody else can use it. Capitals, accents and spaces don't make it different.",
  "Escribe cómo quieres que te llamen.": "Type what you want to be called.",
  "Guardando…": "Saving…",
  "Guardar": "Save",
  "Más despacio: espera un momento.": "Slow down: wait a moment.",
  "Sin conexión: se comprobará al conectar.": "Offline: it'll be checked when you connect.",
  "Tu apodo": "Your nickname",
  "Tu nombre en las salas, en el chat y sobre tu jugador. Es único: nadie más puede llamarse igual.":
    "Your name in rooms, in chat and above your player. It's unique: nobody else can use it.",
  "«{nick}» ya es de otro jugador. Elige otro: por ahora juegas como {now}.":
    "“{nick}” already belongs to another player. Pick another one: for now you're playing as {now}.",
  "✓ Libre": "✓ Available",
  "✓ Libre. Es tuyo si lo guardas.": "✓ Available. It's yours if you save it.",
  "✗ Ese no vale. Prueba con otro.": "✗ That one isn't allowed. Try another.",
  "✗ Ya lo tiene otro jugador": "✗ Another player already has it",
  "✗ Ya lo tiene otro jugador. Prueba con otro (un número también vale).":
    "✗ Another player already has it. Try another (adding a number works too).",

  // --- Amigos 2.0: privados, bloquear, jugaste con (2026-09-26)
  "+ Añadir": "+ Add",
  "Apodo o código de amigo": "Nickname or friend code",
  "Aún no os habéis escrito. Rompe el hielo: «¿echamos unas partidas?»": "You haven't talked yet. Break the ice: “fancy a few games?”",
  "Bloqueados": "Blocked",
  "Bloquear": "Block",
  "Desbloquear": "Unblock",
  "Escribe a {nick}…": "Message {nick}…",
  "Escribe arriba el apodo de alguien, pásale tu código, o pulsa su nombre en el chat para añadirle.":
    "Type someone's nickname above, share your code, or tap their name in the chat to add them.",
  "Escribirle": "Message them",
  "Ese eres tú": "That's you",
  "Ficha": "Card",
  "Has bloqueado a {nick}": "You blocked {nick}",
  "Has bloqueado a {nick}. Puedes desbloquearle en Amigos.": "You blocked {nick}. You can unblock them in Friends.",
  "Invitación enviada a {nick}": "Invite sent to {nick}",
  "Invitar": "Invite",
  "Jugaste con": "You played with",
  "Lo tienes bloqueado: desbloquéalo antes en Amigos": "You've blocked them: unblock them first in Friends",
  "Mensaje privado": "Private message",
  "Más opciones": "More options",
  "No hay nadie con ese apodo o código": "Nobody has that nickname or code",
  "Quitarle o bloquearle borra esta conversación. Si le bloqueas, no te llegará nada suyo: ni solicitudes, ni invitaciones, ni mensajes.":
    "Removing or blocking them deletes this conversation. If you block them, nothing of theirs reaches you: no requests, no invites, no messages.",
  "Responder": "Reply",
  "Ver mensajes anteriores": "Show earlier messages",
  "Volver a amigos": "Back to friends",
  "{nick} ya no está en tus amigos": "{nick} is no longer your friend",
  "{n} sin leer": "{n} unread",

  // --- Ficha de amigo, segunda version (2026-09-26)
  "Amigos desde el {fecha}": "Friends since {fecha}",
  "Aún no habéis jugado en el mismo equipo": "You haven't played on the same team yet",
  "Aún no has jugado online: de momento, gana por incomparecencia.": "You haven't played online yet: for now, they win by walkover.",
  "Cara a cara": "Head to head",
  "Cuando juegue, aquí veréis quién manda: media, goles, MVP y trofeos, cara a cara.":
    "Once they play, this is where you'll see who's boss: overall, goals, MVPs and trophies, head to head.",
  "De los dos · {n}": "Both · {n}",
  "Desconectado": "Offline",
  "Empate técnico: {a} para cada uno.": "Dead even: {a} each.",
  "En racha: {n} victorias seguidas.": "On fire: {n} wins in a row.",
  "Filtrar trofeos": "Filter trophies",
  "Igualados en {what}.": "Level on {what}.",
  "Invitar a tu sala": "Invite to your room",
  "Juntos perdéis más de lo que ganáis. Seguro que es culpa suya.": "Together you lose more than you win. Surely it's their fault.",
  "Juntos sois un problema para cualquiera.": "Together you're a problem for anyone.",
  "La primera vez siempre cuesta. Métete en su sala o tráetelo a la tuya.": "The first time is always the hardest. Jump into their room or bring them to yours.",
  "Le sacas {d} en {what}.": "You're {d} ahead on {what}.",
  "Lleva {n} días seguidos jugando.": "They've played {n} days in a row.",
  "Los dos": "Both of you",
  "Media {n}": "Overall {n}",
  "Mensaje": "Message",
  "Nada por aquí.": "Nothing here.",
  "Nadie aún": "Nobody yet",
  "Nv {n}": "Lv {n}",
  "Os entendéis. Casi siempre.": "You understand each other. Almost always.",
  "Quitarle o bloquearle borra vuestra conversación. Si le bloqueas, no te llegará nada suyo.":
    "Removing or blocking them deletes your conversation. If you block them, nothing of theirs reaches you.",
  "Récord de goles en un partido": "Most goals in a match",
  "Solo suyos · {n}": "Only theirs · {n}",
  "Solo tuyos · {n}": "Only yours · {n}",
  "Su mejor racha: {n} victorias seguidas.": "Their best run: {n} wins in a row.",
  "Te saca {d} en {what}.": "They're {d} ahead on {what}.",
  "Toca una fila para ver la diferencia.": "Tap a row to see the gap.",
  "Todos": "All",
  "Unirse a {sala}": "Join {sala}",
  "Vas por delante en {a} de {n}. Que no se te suba.": "You're ahead in {a} of {n}. Don't let it go to your head.",
  "Visto {ago}": "Seen {ago}",
  "ganados": "won",
  "la última vez": "last time",
  "partidos juntos": "matches together",
  "victorias": "wins",
  "{nick} aún no ha estrenado el online": "{nick} hasn't played online yet",
  "{nick} te gana en {b} de {n}. Hay trabajo.": "{nick} beats you in {b} of {n}. Get to work.",
  "{nick} tiene {a} de {n} trofeos. Tú, {b}.": "{nick} has {a} of {n} trophies. You've got {b}.",
  "{n} partidos online": "{n} online matches",
  "{pct}% de victorias juntos": "{pct}% wins together",
  "Tus atributos y los suyos": "Your attributes and theirs",

  // --- Equipaciones de la carrera y sus cortes (2026-09-26)
  "Tiburón": "Shark",
  "Pistacho": "Pistachio",
  "Rosa Chicle": "Bubblegum",
  "Menta y Marino": "Mint & Navy",
  "Burdeos y Oro": "Burgundy & Gold",
  "Mostaza y Café": "Mustard & Coffee",
  "Arlequín": "Harlequin",
  "Vikingo": "Viking",
  "Nórdico": "Nordic",
  "Lava": "Lava",
  "Cielo y Nube": "Sky & Cloud",
  "Petróleo y Lima": "Petrol & Lime",
  "Retro 70": "Retro 70s",
  "Radiactivo": "Radioactive",
  "Uva": "Grape",
  "Salmón y Marino": "Salmon & Navy",
  "Carbón y Brasa": "Coal & Ember",
  "Sandía": "Watermelon",
  "Tricolor": "Tricolour",
  "Desierto": "Desert",
  "Pingüino": "Penguin",
  "Azul Eléctrico": "Electric Blue",
  "Cereza": "Cherry",
  "Bosque": "Forest",
  "Hielo": "Ice",
  "Sangre y Arena": "Blood & Sand",
  "Medianoche": "Midnight",
  "Coral": "Coral",
  "Cuartos": "Quarters",
  "Galón": "Chevron",
  "Franja": "Centre stripe",
  "Cruz": "Cross",

  // --- La carrera: el movil, los clubes y sus estadios (2026-09-26)
  "Liga del Barrio":
    "Neighbourhood League",
  "Regional":
    "Regional",
  "Segunda":
    "Second Division",
  "Primera":
    "First Division",
  "con el autobús aparcado":
    "with the bus parked",
  "presionando hasta al árbitro":
    "pressing everyone, the referee included",
  "al toque, aunque no sepamos":
    "passing it around, even if we can't",
  "al pelotazo, y que Dios reparta suerte":
    "hoofing it and praying",
  "a la contra, esperando el error ajeno":
    "on the counter, waiting for someone else's mistake",
  "Presión":
    "Press",
  "Toque":
    "Tiki-taka",
  "Patadón":
    "Hoofball",
  "Contra":
    "Counter",
  "Aparcan el autobús y le echan el freno de mano.":
    "They park the bus and pull the handbrake.",
  "Presionan hasta al utillero.":
    "They press the kit man.",
  "Se la pasan como si cobraran por pase.":
    "They pass like they're paid per pass.",
  "El balón pasa más tiempo en el aire que en el suelo.":
    "The ball spends more time in the air than on the grass.",
  "Te regalan el balón. Es una trampa.":
    "They give you the ball. It's a trap.",
  "Soy {agent}, tu agente. Me llevo el diez por ciento de todo lo que ganes. De momento es el diez por ciento de nada, así que vamos bien.":
    "I'm {agent}, your agent. I take ten percent of everything you earn. Right now that's ten percent of nothing, so we're off to a great start.",
  "Bienvenido al {club}. Aquí jugamos {estilo}. Tú corre, que para pensar ya estoy yo.":
    "Welcome to {club}. Here we play {estilo}. You run. I'll do the thinking.",
  "{paper}: «El {club} ficha a {name}, un chaval de 17 años. Nadie sabe quién es. Él tampoco.»":
    "{paper}: “{club} sign {name}, 17. Nobody knows who they are. Neither do they.”",
  "Hijo, dice la vecina que ahora eres futbolista. Abrígate, que en el campo hace fresco.":
    "Love, the neighbour says you're a footballer now. Wrap up, it's chilly on that pitch.",
  "El {rival} aparca el autobús y le echa el freno de mano. Paciencia, que alguno se dormirá.":
    "{rival} park the bus and pull the handbrake. Be patient, someone will nod off.",
  "El {rival} presiona hasta al utillero. Toca rápido o te comen.":
    "{rival} press the kit man. Pass quick or they'll eat you alive.",
  "El {rival} se la pasa como si cobrara por pase. Quítasela y corre.":
    "{rival} pass like they're paid per pass. Steal it and run.",
  "El {rival} juega al pelotazo. Mira al cielo y reza.":
    "{rival} hoof it. Look up and pray.",
  "El {rival} te deja el balón. Es una trampa. No te lo creas.":
    "{rival} will give you the ball. It's a trap. Don't fall for it.",
  "{paper}: «{star}, la estrella del {rival}: \"No sé quién es {name}\". Pues que se entere.»":
    "{paper}: “{star}, {rival}'s star: 'Never heard of {name}.' Time he did.”",
  "{paper}: «El {rival}, antes de jugar contra el {club}: \"Vamos a por los tres puntos\". Originalidad: cero.»":
    "{paper}: “{rival} before facing {club}: 'We're going for the three points.' Originality: zero.”",
  "{paper}: «{rivalcoach}, técnico del {rival}: \"Máximo respeto al rival\". Traducción: no os conocen de nada.»":
    "{paper}: “{rivalcoach}, {rival} boss: 'Maximum respect for the opponent.' Translation: they've never heard of you.”",
  "Bien. No te acostumbres.":
    "Good. Don't get used to it.",
  "Hemos ganado. Mañana entreno a las 8, por si te venías arriba.":
    "We won. Training at 8 tomorrow, in case you were getting ideas.",
  "Así se juega. Lo diré en la rueda de prensa como si fuera idea mía.":
    "That's how it's done. I'll say it in the press conference like it was my idea.",
  "Un empate. Ni fu ni fa. Como tu pierna mala.":
    "A draw. Meh. Like your weak foot.",
  "Un punto es un punto. Lo dicen todos los entrenadores que no saben qué decir. Como yo.":
    "A point is a point. Every manager says that when they've nothing to say. Like me.",
  "Hoy no. Ni tú, ni yo, ni el utillero.":
    "Not today. Not you, not me, not the kit man.",
  "He visto cosas peores. No recuerdo cuándo.":
    "I've seen worse. Can't remember when.",
  "Mañana doble sesión. La culpa, repartida: un noventa por ciento para vosotros.":
    "Double session tomorrow. Blame is shared: ninety percent yours.",
  "Te estuvimos esperando. Jugamos sin ti. Nadie notó la diferencia. Es broma. O no.":
    "We waited for you. We played without you. Nobody noticed. Kidding. Or not.",
  "Hoy has estado enorme. No se lo digas a nadie, que luego pedís aumento.":
    "You were huge today. Don't tell anyone, or you'll all ask for a raise.",
  "Voy a ver el partido otra vez. Por si fue una pesadilla. Spoiler: no.":
    "I'm going to watch the game again. Just in case it was a nightmare. Spoiler: it wasn't.",
  "{paper}: «El {club} juega sin {name}. Nadie da explicaciones. Su agente, tampoco.»":
    "{paper}: “{club} play without {name}. No explanation given. Not even by their agent.”",
  "{paper}: «Hat-trick de {name}. Su madre ya lo ha puesto de fondo de pantalla.»":
    "{paper}: “Hat-trick for {name}. Their mum has already made it her wallpaper.”",
  "{paper}: «Doblete de {name}. El portero del {rival} se plantea cambiar de oficio.»":
    "{paper}: “A brace for {name}. {rival}'s keeper is considering a career change.”",
  "{paper}: «{name}, un {grade}. Y porque no se puede poner menos.»":
    "{paper}: “{name}: {grade}. Only because it doesn't go lower.”",
  "{paper}: «Baño del {rival} al {club}. Hay quien pide la vuelta del entrenador anterior. Y del anterior.»":
    "{paper}: “{rival} thrash {club}. Fans want the previous manager back. And the one before.”",
  "{paper}: «Goleada del {club}. El {rival} pide que no cuente.»":
    "{paper}: “{club} run riot. {rival} ask for it not to count.”",
  "{paper}: «{name} decide ante el {rival}. Se confirman los rumores: sabe jugar.»":
    "{paper}: “{name} settles it against {rival}. Rumours confirmed: they can play.”",
  "{paper}: «{name} marca y el {club} pierde. Como achicar agua en el Titanic.»":
    "{paper}: “{name} scores, {club} lose. Like bailing water on the Titanic.”",
  "{paper}: «{name}, el mejor del partido. Él tampoco se lo explica.»":
    "{paper}: “{name}, man of the match. They can't explain it either.”",
  "{paper}: «{name} reparte asistencias como un camarero en feria.»":
    "{paper}: “{name} hands out assists like a waiter at a village fair.”",
  "{paper}: «Se busca delantero. Responde al nombre de {name}. Si lo ven, avisen.»":
    "{paper}: “Missing: one striker. Answers to {name}. If found, please call.”",
  "{paper}: «Empate entre el {club} y el {rival}. Nadie recordará este partido. Nosotros tampoco.»":
    "{paper}: “{club} and {rival} draw. Nobody will remember this game. Neither will we.”",
  "{paper}: «El {club} gana sin brillar. Sin brillar nada, en serio.»":
    "{paper}: “{club} win without shining. Not even a flicker, honestly.”",
  "{paper}: «Derrota del {club}. {coach} habla de \"detalles\". Los detalles fueron los goles.»":
    "{paper}: “{club} lose. {coach} blames 'details'. The details were the goals.”",
  "¡¡VAMOOOS!! Esto es otra cosa.":
    "LET'S GOOOO!! Now we're talking.",
  "{name} presidente.":
    "{name} for president.",
  "Así sí. Mañana ya pedimos fichajes.":
    "That's more like it. Tomorrow we demand signings.",
  "Empate. Me doy de baja. (No me doy de baja.)":
    "A draw. I'm cancelling my season ticket. (I'm not.)",
  "Pagamos la entrada para esto.":
    "We paid for a ticket for this.",
  "Devolvedme el bocadillo.":
    "I want my sandwich back.",
  "Lo que se sufre por unos colores.":
    "The things we suffer for a shirt.",
  "Que alguien le explique a {name} dónde está la portería.":
    "Can someone show {name} where the goal is.",
  "{name} es lo único bueno de este club. Y del barrio.":
    "{name} is the only good thing about this club. And this town.",
  "{paper}: «El {club} encadena tres victorias y ya se habla de proyecto. De qué proyecto, no se sabe.»":
    "{paper}: “Three wins in a row for {club}, and people are talking about a 'project'. Nobody knows which.”",
  "{paper}: «Tres derrotas seguidas. El presidente da su apoyo total a {coach}: está sentenciado.»":
    "{paper}: “Three straight defeats. The chairman gives {coach} his full backing: he's done for.”",
  "{paper}: «{name} levanta la Primera con el {club}. Ya puede morir tranquilo. Su agente, más.»":
    "{paper}: “{name} lifts the First Division with {club}. They can die happy now. Their agent, happier.”",
  "{paper}: «¡El {club}, campeón de {division}! La afición lo celebra en la rotonda de siempre.»":
    "{paper}: “{club} are {division} champions! Fans celebrate at the usual roundabout.”",
  "{paper}: «El {club} sube a {nextDivision}. Nadie sabe muy bien cómo, pero sube.»":
    "{paper}: “{club} go up to the {nextDivision}. Nobody quite knows how, but up they go.”",
  "{paper}: «El {club} baja a {nextDivision}. El presidente anuncia un proyecto ilusionante.»":
    "{paper}: “{club} drop to the {nextDivision}. The chairman announces an exciting new project.”",
  "{paper}: «El {club} acaba último en el Barrio. Por suerte, más abajo no hay nada.»":
    "{paper}: “{club} finish bottom of the Neighbourhood League. Luckily there's nothing below it.”",
  "{paper}: «Temporada tranquila del {club}: {pos}.º. Ni frío ni calor. Tibia, como la cerveza del bar.»":
    "{paper}: “Quiet season for {club}: {pos}th. Lukewarm, like the beer at the club bar.”",
  "Temporada {season}: {goals} goles y un {grade} de media. Podría ser peor. Podrías ser el portero.":
    "Season {season}: {goals} goals and a {grade} average. Could be worse. You could be the keeper.",
  "Felicidades. Veintiuno. Tu primo ya tiene plaza fija. Solo lo digo.":
    "Happy birthday. Twenty-one. Your cousin has a permanent job. Just saying.",
  "Treinta, hijo. Tu primo ya tiene hipoteca. ¿Y tú qué tienes? Ah, sí: tendinitis.":
    "Thirty, love. Your cousin has a mortgage. And what have you got? Oh yes: tendinitis.",
  "Hijo, que ya tienes una edad. ¿Y si te vienes a la tienda? Buscan reponedor.":
    "Love, you're not getting any younger. Why not come to the shop? They need a shelf stacker.",
  "Felicidades, hijo. {age} años. ¿Has pensado en estudiar algo, por si acaso?":
    "Happy birthday, love. {age}. Have you thought about studying something, just in case?",
  "{paper}: «{name} cumple {age}: ya le llaman \"veterano\" con cariño, y \"abuelo\" sin él.»":
    "{paper}: “{name} turns {age}: 'veteran' when people are being kind, 'fossil' when they're not.”",
  "Pagan puntual. Casi siempre.":
    "They pay on time. Almost always.",
  "Tienen un proyecto. No saben cuál, pero tienen uno.":
    "They have a project. They don't know what it is, but they have one.",
  "El presidente quiere tu perfil. El de Instagram, creo.":
    "The chairman wants your profile. Your Instagram one, I think.",
  "Dicen que serás importante. Se lo dicen a todos.":
    "They say you'll be important. They say that to everyone.",
  "El estadio tiene techo. En una grada.":
    "The stadium has a roof. Over one stand.",
  "Tienen fisio. Lo comparten con el equipo de balonmano.":
    "They have a physio. Shared with the handball team.",
  "No ha llamado nadie. He comprobado que el móvil tenía batería. Tenía.":
    "Nobody called. I checked the phone had battery. It did.",
  "¡Primera! Te quiere el {club}. Me voy a comprar un barco. Pequeño, de momento.":
    "First Division! {club} want you. I'm buying a boat. A small one, for now.",
  "Ha llamado el {club}. Dicen que te han visto jugar. No pregunté cuándo.":
    "{club} called. They say they've seen you play. I didn't ask when.",
  "Tengo {n} ofertas encima de la mesa. Bueno, en el móvil. Elige, que yo cobro igual.":
    "I've got {n} offers on the table. Well, on my phone. Pick one, I get paid either way.",
  "A tu edad, cada oferta es un regalo. Pocas, y huelen a naftalina.":
    "At your age, every offer is a gift. Few of them, and they smell of mothballs.",
  "Bienvenido al {club}. Aquí jugamos {estilo}. Olvida lo que te enseñó {old}. Sobre todo eso.":
    "Welcome to {club}. Here we play {estilo}. Forget what {old} taught you. Especially that.",
  "{paper}: «{name} ficha por el {club}. {agent} se frota las manos.»":
    "{paper}: “{name} joins {club}. {agent} rubs his hands.”",
  "Te quedas. Me alegro. No se lo digas a nadie, pero me alegro.":
    "You're staying. I'm glad. Don't tell anyone, but I'm glad.",
  "Te quedas la camiseta del {club}. Ya puedes vestirla online.":
    "You keep the {club} shirt. You can wear it online now.",
  "Te has cambiado la camiseta con {star}, del {rival}. Olía a linimento y a derrota. Ya puedes vestirla online.":
    "You swapped shirts with {star} from {rival}. It smelled of liniment and defeat. You can wear it online now.",
  "Equipación nueva: {kit}. {how}":
    "New kit: {kit}. {how}",
  "Gana tu primera liga, la que sea.":
    "Win your first league, any league.",
  "Llega a Primera.":
    "Reach the First Division.",
  "Gana la Primera.":
    "Win the First Division.",
  "Marca 50 goles en tu carrera.":
    "Score 50 career goals.",
  "Marca 150 goles en tu carrera.":
    "Score 150 career goals.",
  "Da 50 asistencias en tu carrera.":
    "Make 50 career assists.",
  "Sé el MVP 25 veces.":
    "Be MVP 25 times.",
  "Juega 100 partidos de carrera.":
    "Play 100 career matches.",
  "Asciende dos veces seguidas.":
    "Win promotion twice in a row.",
  "Entra en el salón de la fama.":
    "Enter the hall of fame.",
  "{paper}: «{name} cuelga las botas tras {seasons} temporadas. Las botas, aliviadas.»":
    "{paper}: “{name} hangs up their boots after {seasons} seasons. The boots are relieved.”",
  "Ha sido un placer. El diez por ciento de un placer, concretamente.":
    "It's been a pleasure. Ten percent of a pleasure, to be precise.",
  "Hijo, ya era hora. Tu habitación sigue igual. Tus trofeos, también: sin polvo.":
    "Love, about time. Your room is just as you left it. Your trophies too: dust-free.",
  "Leyenda. Tendrá una estatua. Fea, pero una estatua.":
    "Legend. They'll get a statue. An ugly one, but a statue.",
  "Llegó a Primera. En su pueblo le han puesto una calle. Es un callejón.":
    "Made the First Division. Their hometown named a street after them. It's an alley.",
  "Un clásico de Segunda. Los árbitros le saludaban por su nombre.":
    "A Second Division classic. Referees greeted them by name.",
  "Leyenda del Regional. Invicto en las barbacoas del club.":
    "Regional legend. Unbeaten at club barbecues.",
  "Nunca salió del barrio. El barrio tampoco lo echará de menos.":
    "Never left the neighbourhood. The neighbourhood won't miss them either.",
  "Su presidente está imputado, pero ilusionado.":
    "Their chairman is under investigation, but excited.",
  "Entrenan en un parking. Lo cuentan con orgullo.":
    "They train in a car park. They say it proudly.",
  "Su estrella cobra en bocadillos.":
    "Their star is paid in sandwiches.",
  "Llevan tres años sin ganar fuera. Ni a las cartas.":
    "Three years without an away win. Not even at cards.",
  "Tienen más ultras que socios.":
    "More ultras than members.",
  "Su portero es el hijo del presidente. Se nota.":
    "Their keeper is the chairman's son. It shows.",
  "El césped es de plástico. Las ideas, también.":
    "The pitch is plastic. So are the ideas.",
  "Ponen la música de Rocky en el vestuario. No funciona.":
    "They play the Rocky theme in the dressing room. It doesn't work.",
  "Su delantero centro tiene 41 años y dos hernias.":
    "Their centre-forward is 41 with two hernias.",
  "Han fichado a un influencer. Tiene más seguidores que minutos.":
    "They signed an influencer. More followers than minutes played.",
  "Su himno dura nueve minutos. Nadie se lo sabe.":
    "Their anthem lasts nine minutes. Nobody knows the words.",
  "Celebran los córners como si fueran goles.":
    "They celebrate corners like goals.",
  "Su dueño vive en otro huso horario y opina en todos.":
    "Their owner lives in another time zone and has opinions in all of them.",
  "Tienen un director deportivo, un director de contenidos y ningún lateral.":
    "They have a sporting director, a head of content and no full-backs.",
  "Pagan las fichas en criptomonedas. Este mes valen un bocadillo.":
    "They pay wages in crypto. This month it's worth a sandwich.",
  "Su estadio lleva el nombre de una casa de apuestas. Y se nota en las alineaciones.":
    "Their stadium is named after a betting site. You can tell from the line-ups.",
  "En su pueblo todo es gigante: el semáforo, la cabina, la ilusión. El presupuesto, no.":
    "In their town everything is giant: the traffic light, the phone box, the dreams. Not the budget.",
  "Presupuesto de Champions, ideas de chiringuito.":
    "Champions League budget, beach-bar ideas.",

  // --- Equipaciones bloqueadas (2026-09-26)
  "Bloqueada": "Locked",
  "La viste un club de la carrera. Acaba una temporada con ellos, o cámbiatela con su estrella siendo el MVP.":
    "A career club wears it. Finish a season with them, or swap shirts with their star after beating them as MVP.",
  "Se gana en la carrera: llega a Primera y diseña la tuya.": "Earned in the career: reach the First Division and design your own.",
  "Se gana en la carrera: {how}": "Earned in the career: {how}",
  "Tienes {a} de {n}. El resto se gana en la carrera.": "You have {a} of {n}. The rest are earned in the career.",

  // --- Partidos de carrera (2026-09-26)
  "Tu nota": "Your rating",
  "Clasificación": "Standings",
  "{n} pts": "{n} pts",
  "1 punto": "1 pt",
  "{n}º": "#{n}",
  "Jornada {n} de {total}": "Matchday {n} of {total}",
  "¡Campeones de {division}!": "{division} champions!",
  "¡Ascenso a {division}!": "Promoted to {division}!",
  "Descenso a {division}.": "Relegated to {division}.",
  "Equipación nueva: {kit}": "New kit: {kit}",
  "Ya puedes diseñar tu equipación «A medida».": "You can now design your own “Custom” kit.",
  "Tu móvil": "Your phone",
  "Míster": "Coach",
  "Agente": "Agent",
  "Prensa": "Press",
  "Afición": "Fans",
  "Mamá": "Mom",
  "Fynta": "Fynta",
  "Siguiente jornada": "Next matchday",
  "¿Te vas del partido?": "Leaving the match?",
  "Si te vas, se juega sin ti y el resultado cuenta. Aquí no se repite nada.":
    "If you leave, it's played without you and the result counts. Nothing gets replayed here.",
  "Me voy": "I'm leaving",
  "Sigo jugando": "Keep playing",

  // --- Pantallas de la carrera (2026-09-26)
  "17 a {n} años": "Ages 17 to {n}",
  "Aún ninguna. La primera siempre es la más difícil de olvidar.": "None yet. The first one is always the hardest to forget.",
  "Aún no hay nadie. El primero en retirarse se queda con la mejor plaza. Es la única.": "Nobody here yet. The first to retire gets the best spot. It's the only one.",
  "Bajan {n}": "{n} go down",
  "CARRERA": "CAREER",
  "Calendario": "Fixtures",
  "Camisetas de esta carrera": "Shirts from this career",
  "Campeón": "Champion",
  "Carrera": "Career",
  "Carrera terminada. El salón de la fama te espera.": "Career over. The hall of fame awaits.",
  "Carrera · Temporada {n}": "Career · Season {n}",
  "Casa": "Home",
  "Cerraste a mitad de partido: la jornada se jugó sin ti.": "You closed the game mid-match: the matchday was played without you.",
  "Club": "Club",
  "Colgar las botas": "Hang up the boots",
  "Colgarlas": "Hang them up",
  "Con {age} años no hay contrato que te salve. Toca colgar las botas.": "At {age}, no contract can save you. Time to hang up the boots.",
  "Cómo te van a corear": "What the crowd will chant",
  "DG": "GD",
  "De los 17 a los 35. Del barrio a Primera.": "From 17 to 35. From the neighbourhood to the First Division.",
  "Diferencia de goles": "Goal difference",
  "División": "Division",
  "EMPEZAR CARRERA": "START CAREER",
  "Edad": "Age",
  "Elige tu primer club · Liga del Barrio": "Pick your first club · Neighbourhood League",
  "Elige un club. Ninguno te va a venir a buscar.": "Pick a club. None of them is coming to get you.",
  "Empezar otra": "Start over",
  "En casa": "Home",
  "Fichar": "Sign",
  "Fin de la carrera": "End of the career",
  "Fin de la temporada {n}": "End of season {n}",
  "Fuera": "Away",
  "G-E-P": "W-D-L",
  "Ganados, empatados, perdidos": "Won, drawn, lost",
  "JUGAR": "PLAY",
  "Juegas por la derecha": "You play on the right",
  "Juegas por la izquierda": "You play on the left",
  "J{md}": "MD{md}",
  "La de ahora se pierde para siempre y no entra en el salón de la fama. Las equipaciones que ganaste se quedan.": "The current one is lost forever and doesn't go into the hall of fame. The kits you earned stay.",
  "La temporada que viene, en {division}": "Next season, in {division}",
  "Mejor no": "Better not",
  "Móvil": "Phone",
  "NUEVA CARRERA": "NEW CAREER",
  "Ninguna todavía. Acaba una temporada y la de tu club es tuya.": "None yet. Finish a season and your club's shirt is yours.",
  "No ha llamado nadie. Tu agente jura que el móvil tenía batería.": "Nobody called. Your agent swears the phone was charged.",
  "Nota": "Rating",
  "Nota media": "Avg rating",
  "Nueva carrera": "New career",
  "Ofertas": "Offers",
  "Pie bueno": "Stronger foot",
  "Ponte un nombre. «El chaval» no sale bien en las camisetas.": "Give yourself a name. “The kid” doesn't look good on a shirt.",
  "Pos.": "Pos.",
  "Posición": "Position",
  "Pts": "Pts",
  "Puntos": "Points",
  "Quedarme en el {club}": "Stay at {club}",
  "Salón de la fama": "Hall of fame",
  "Se acabó: entras en el salón de la fama y no hay vuelta atrás. Tus equipaciones se quedan.": "That's it: you enter the hall of fame and there's no way back. Your kits stay.",
  "Su estrella: {star} · Su míster: {coach}": "Their star: {star} · Their coach: {coach}",
  "Suben {n}": "{n} go up",
  "Tabla": "Table",
  "Temp.": "Season",
  "Temporadas": "Seasons",
  "Tienes 17 años, unas botas prestadas y un sueño. Las botas hay que devolverlas.": "You're 17, with borrowed boots and a dream. The boots have to go back.",
  "T{s} · Fin de temporada": "S{s} · End of season",
  "T{s} · J{md}": "S{s} · MD{md}",
  "Títulos": "Titles",
  "Una más": "One more",
  "Volver": "Back",
  "sin ti": "without you",
  "{club} · Fin de temporada": "{club} · End of season",
  "{club} · {division} · Jornada {n} de {total}": "{club} · {division} · Matchday {n} of {total}",
  "{n} años": "{n} years old",
  "{n} ligas de Primera": "{n} First Division titles",
  "{pos} de {n} en {division}": "{pos} of {n} in {division}",
  "¿Colgar las botas?": "Hang up the boots?",
  "¿Empezar otra carrera?": "Start another career?",
  "Delantero": "Forward",
  "Medio": "Midfielder",
  "Diestro": "Right-footed",
  "Zurdo": "Left-footed",
  "Velocidad": "Pace",
  "Disparo": "Shooting",
  "Pase": "Passing",
  "Fondo": "Stamina",
  "Si marcas, eres un genio. Si no, un problema.": "Score and you're a genius. Don't and you're a problem.",
  "Corres por todos y la foto se la lleva otro.": "You run for everyone and someone else gets the photo.",
  "Nadie se acuerda de ti hasta que fallas.": "Nobody remembers you until you mess up.",
  "DEL": "FW",
  "MED": "MF",
  "DEF": "DF",
  "Tu carrera se ha puesto al día con la de tu cuenta.": "Your career has caught up with the one on your account.",

  // --- Dificultad del Partido rapido (2026-09-26)
  "Dificultad": "Difficulty",
  "BARRIO": "STREET",
  "REGIONAL": "REGIONAL",
  "SEGUNDA": "2ND DIV",
  "PRIMERA": "1ST DIV",
  "fácil": "easy",
  "media": "medium",
  "difícil": "hard",
  "la de siempre": "classic",
  "Torpes, lentos y con resaca. Para empezar.": "Clumsy, slow and hungover. A good place to start.",
  "Ya se defienden. Más o menos.": "They can hold their own. More or less.",
  "Te lo ponen difícil, y encima protestan.": "They make it hard, and complain on top of that.",
  "La IA de siempre. Sin piedad.": "The classic AI. No mercy.",

  // --- Estadisticas mundiales (2026-09-27)
  "Aparecer": "Show me",
  "Aparecer en las clasificaciones": "Appear in the rankings",
  "Aquí solo cuentan partidos online, y el servidor los rehace uno a uno para que nadie haga trampas. Contra la IA y la carrera no cuentan.": "Only online matches count here, and the server replays each one so nobody can cheat. Matches against the AI and the career don't count.",
  "Asist./partido": "Assists/match",
  "Aún ninguna. Se ganan jugando online: rachas, récords, top 10, campeón de la semana…": "None yet. You earn them playing online: streaks, records, top 10, player of the week…",
  "Aún no hay nadie aquí. El primero se queda el puesto uno.": "Nobody here yet. The first one takes number one.",
  "Aún no hay récords. El primer partido online los pone todos.": "No records yet. The first online match sets them all.",
  "Aún no puntúas aquí.": "You don't score here yet.",
  "Cada partido lo rehace el servidor con las jugadas de todos. Si algo no cuadra, no cuenta.": "The server replays every match with everyone's inputs. If anything doesn't add up, it doesn't count.",
  "Campeón de la semana ×{n}": "Player of the week ×{n}",
  "Cargar más": "Load more",
  "Competidor": "Competitor",
  "Compite contra el mundo": "Compete against the world",
  "Con {n} partidos o más en el periodo.": "With {n} or more matches in the period.",
  "Divisiones": "Divisions",
  "División {tier}": "{tier} division",
  "ESTADÍSTICAS MUNDIALES": "WORLD STATISTICS",
  "El que más ganó una semana (con 3 partidos o más).": "Won the most in a week (with 3 matches or more).",
  "En colocación": "Placement",
  "Esta ficha no es pública.": "This card isn't public.",
  "Estadísticas mundiales": "World statistics",
  "Goles/partido": "Goals/match",
  "Hasta donde llegó en una temporada ya cerrada.": "How high they got in a finished season.",
  "Hat-tricks ×{n}": "Hat-tricks ×{n}",
  "JUGAR ONLINE": "PLAY ONLINE",
  "Juega online para poder compararte.": "Play online to compare yourself.",
  "La puntuación sube y baja con cada partido contra personas: ganar a un equipo mejor da más, perder contra uno peor quita más. Contra bots no se mueve.": "Your rating goes up and down with every match against people: beating a better team gives more, losing to a worse one takes more. Against bots it doesn't move.",
  "La semana se reinicia en {left}.": "The week resets in {left}.",
  "Lo más alto. A defenderlo.": "The very top. Now defend it.",
  "Los 5 primeros son de colocación. Cada mes empieza una temporada nueva y todos se acercan a 1000 a la mitad: lo ganado cuenta, pero hay que volver a demostrarlo.": "The first 5 are placement matches. Every month a new season starts and everyone moves halfway back to 1000: what you earned counts, but you have to prove it again.",
  "Mejor partido": "Best match",
  "Mejor que el {p} % de los clasificados": "Better than {p}% of ranked players",
  "Mejor temporada: {tier}": "Best season: {tier}",
  "Mejores marcas": "Personal bests",
  "Mundo": "World",
  "Ninguno de tus amigos puntúa aquí todavía.": "None of your friends score here yet.",
  "No sales en las clasificaciones: los demás no te ven. Tú sí te ves.": "You're not in the rankings: others can't see you. You can.",
  "Para entrar en esta clasificación te faltan {n} partidos online.": "You need {n} more online matches to enter this ranking.",
  "Para entrar: te faltan {n} partidos contra personas.": "To enter: {n} more matches against people.",
  "Partidos con tres goles o más.": "Matches with three goals or more.",
  "Pases buenos": "Good passes",
  "Por modo": "By mode",
  "Puesto en la clasificación de siempre.": "Position in the all-time ranking.",
  "Qué se clasifica": "What is ranked",
  "Racha de {n}": "Streak of {n}",
  "Resumen": "Summary",
  "Robos": "Steals",
  "Récord del mundo": "World record",
  "Récords": "Records",
  "Sin conexión.": "Offline.",
  "Sin conexión. Las estadísticas mundiales viven en el servidor: vuelve a intentarlo en un momento.": "Offline. World statistics live on the server: try again in a moment.",
  "Sin partidos todavía.": "No matches yet.",
  "Solo partidos contra personas. Temporada {season}: acaba en {left}.": "Only matches against people. Season {season}: ends in {left}.",
  "Te faltan {n} partidos contra personas para tener división.": "{n} more matches against people to get a division.",
  "Te faltan {n} puntos para {tier}": "{n} points to {tier}",
  "Temporadas pasadas": "Past seasons",
  "Todos los modos": "All modes",
  "Top {n} mundial · {metric}": "World top {n} · {metric}",
  "Tu división esta temporada, contra personas.": "Your division this season, against people.",
  "Tu sitio": "Your spot",
  "Ver mi ficha": "See my card",
  "Victorias seguidas online.": "Wins in a row online.",
  "acaba en {left}": "ends in {left}",
  "contra bots": "vs bots",
  "contra personas": "vs people",
  "de {n} en {metric}": "of {n} in {metric}",
  "desde {n}": "from {n}",
  "pico {n}": "peak {n}",
  "{mmr} puntos": "{mmr} points",
  "{mmr} puntos · {w}-{d}-{l} contra personas": "{mmr} points · {w}-{d}-{l} vs people",
  "{n} PJ": "{n} MP",
  "{n} partidos arbitrados": "{n} refereed matches",
  "{n} partidos contra personas esta temporada.": "{n} matches against people this season.",
  "{n} partidos online.": "{n} online matches.",
  "{tier} · #{rank} del mundo": "{tier} · world #{rank}",
  "Semana": "Week",
  "Temporada": "Season",
  "Siempre": "All time",
  "Platino": "Platinum",
  "Diamante": "Diamond",
  "Más goles en un partido": "Most goals in a match",
  "Más asistencias en un partido": "Most assists in a match",
  "La mayor goleada": "Biggest win",
  "El mejor partido": "Best match ever",
  "La racha más larga": "Longest win streak",
  "Más veces MVP": "Most MVPs",
  "PUNTUACIÓN": "RATING",
  "ASISTENCIAS": "ASSISTS",
  "VICTORIAS": "WINS",
  "% VICTORIAS": "WIN %",
  "puntuación": "rating",
  "la media": "overall",
  "asistencias": "assists",
  "% de victorias": "win %",
  "partidos": "matches",
  "Temporada Oro": "Gold Season",
  "Temporada Platino": "Platinum Season",
  "Temporada Diamante": "Diamond Season",
  "Temporada Leyenda": "Legend Season",
  "Campeón del mundo": "World Champion",
  "Acaba una temporada en {tier} o más.": "Finish a season in {tier} or higher.",
  "Aún ninguna semana cerrada con ganador.": "No week has closed with a winner yet.",
  "Aún no ha acabado ninguna temporada. El primer campeón saldrá a final de mes.": "No season has ended yet. The first champion arrives at the end of the month.",
  "Campeones": "Champions",
  "Campeones de la semana": "Weekly champions",
  "Campeones de temporada": "Season champions",
  "Para el número 1 de una temporada.": "For the number 1 of a season.",
  "Premios de temporada": "Season rewards",
  "Se gana compitiendo online: acaba una temporada mundial en el número 1.": "Earned competing online: finish a world season as number 1.",
  "Se gana compitiendo online: acaba una temporada mundial en {tier} o más.": "Earned competing online: finish a world season in {tier} or higher.",
  "Se ganan para siempre y se usan en todo el juego, también online.": "They're yours forever and work across the whole game, online too.",
  "Tienes {a} de {n}. El resto se gana en la carrera y compitiendo online.": "You have {a} of {n}. The rest are earned in the career and competing online.",
  "semana del {d}": "week of {d}",
  "{n} victorias": "{n} wins",
  "A {nick} le llevas {w}-{l}": "You lead {nick} {w}-{l}",
  "Ahora no": "Not now",
  "Al abrirlo entran en tu sala y os hacéis amigos. No sale en ninguna lista.": "Opening it drops them into your room and makes you friends. It isn't listed anywhere.",
  "Amigo": "Friend",
  "Amigos: {n} conectados": "Friends: {n} online",
  "Avisar": "Nudge",
  "Aún no tienes amigos aquí. Pásale el enlace a alguien: al abrirlo, seréis amigos y estaréis en la misma sala.": "No friends here yet. Send someone the link: when they open it, you'll be friends and in the same room.",
  "Con {nick} vais {w}-{l}": "You and {nick} are level at {w}-{l}",
  "Conectados": "Online",
  "Contra {nick}: {w} victorias, {d} empates, {l} derrotas": "Against {nick}: {w} wins, {d} draws, {l} losses",
  "Copiado. Pégaselo a {nick} por WhatsApp o donde habléis": "Copied. Paste it to {nick} on WhatsApp or wherever you chat",
  "Desconectados": "Offline",
  "Enlace copiado. Pégalo en el grupo": "Link copied. Paste it in the group chat",
  "Espera un poco antes de invitar a más gente": "Hold on a moment before inviting more people",
  "Has jugado con": "You played with",
  "Invitar a alguien que no juega": "Invite someone who doesn't play yet",
  "Invitar a todos ({n})": "Invite everyone ({n})",
  "Jugar juntos": "Play together",
  "Juntos: {w} victorias de {n}": "Together: {w} wins out of {n}",
  "No se pudo copiar": "Couldn't copy",
  "Quieren ser tus amigos": "Friend requests",
  "Sin conexión. Tus amigos aparecen aquí en cuanto vuelva.": "Offline. Your friends will show up here as soon as you're back.",
  "Te invitan": "Invites",
  "Tu código": "Your code",
  "compañero": "teammate",
  "rival": "opponent",
  "victorias-empates-derrotas": "wins-draws-losses",
  "{a} está conectado": "{a} is online",
  "{a} está jugando": "{a} is playing",
  "{a} están conectados": "{a} are online",
  "{a} están jugando": "{a} are playing",
  "{a} y {b}": "{a} and {b}",
  "{a}, {b} y {n} más": "{a}, {b} and {n} more",
  "{nick} está jugando: verá tu invitación al acabar": "{nick} is in a match: they'll see your invite when it ends",
  "{nick} no está conectado. Avísale por otro lado": "{nick} isn't online. Give them a shout elsewhere",
  "{nick} no puede ahora": "{nick} can't right now",
  "{nick} se ha conectado": "{nick} just came online",
  "{nick} te invita a jugar": "{nick} invites you to play",
  "{nick} te lleva {l}-{w}": "{nick} leads you {l}-{w}",
  "{nick} ya está en tu sala": "{nick} is already in your room",
  "{n} amigos se han conectado": "{n} friends just came online",
  "· {n} conectados": "· {n} online",
  "¿Echamos un partido en FYNTA? {url}": "Fancy a match on FYNTA? {url}",
  "¿Te echas un {modo} conmigo en FYNTA? Entra aquí: {url}": "Up for a {modo} with me on FYNTA? Jump in here: {url}",
  "🔔 Avisos con sonido": "🔔 Alert sounds on",
  "🔕 Avisos sin sonido": "🔕 Alert sounds off",
  "Abierto a amigos": "Open to friends",
  "Ahora llevas tú el grupo": "You're leading the party now",
  "Echar": "Kick",
  "El grupo está lleno": "The party is full",
  "En el menú": "In the menu",
  "En tu grupo": "In your party",
  "En una sala": "In a room",
  "Esperando a tu grupo…": "Waiting for your party…",
  "GRUPO": "PARTY",
  "Invitación al grupo enviada a {nick}": "Party invite sent to {nick}",
  "Invitado, esperando respuesta…": "Invited, waiting for an answer…",
  "Invitar al grupo": "Invite to party",
  "Ir con ellos": "Join them",
  "Iréis juntos a las salas y al mismo equipo": "You'll go to rooms together, on the same team",
  "JUGAR CON TU GRUPO": "PLAY WITH YOUR PARTY",
  "Jugando": "Playing",
  "Le has pedido a {nick} entrar en su grupo": "You asked {nick} to join their party",
  "Lleva el grupo": "Party leader",
  "Lleva el grupo {nick}: donde entre, vas detrás.": "{nick} leads the party: wherever they go, you follow.",
  "No": "No",
  "Pasarle el mando": "Make leader",
  "Pedir unirse": "Ask to join",
  "Pide entrar": "Wants to join",
  "Reconectando…": "Reconnecting…",
  "Salir del grupo": "Leave party",
  "Solo con invitación": "Invite only",
  "Te han sacado del grupo": "You were removed from the party",
  "Te invitan a un grupo": "Party invites",
  "Tu grupo": "Your party",
  "Tu grupo está en la sala de {nick}": "Your party is in {nick}'s room",
  "Tu grupo se ha deshecho: te has quedado solo": "Your party broke up: you're on your own",
  "Tu grupo: {names}": "Your party: {names}",
  "Tu grupo: {names}. Entra y jugáis juntos": "Your party: {names}. Jump in and play together",
  "Tú eliges: entra en una sala o pulsa Jugar ya y tu grupo va detrás, en tu equipo.": "You call it: enter a room or hit Play now and your party follows, on your team.",
  "Unirse al grupo": "Join party",
  "Vas con el grupo de {nick}: donde entre, vas detrás": "You're in {nick}'s party: wherever they go, you follow",
  "Vas con tu grupo a la sala de {nick}": "Heading to {nick}'s room with your party",
  "{nick} ha salido del grupo": "{nick} left the party",
  "{nick} lleva ahora el grupo": "{nick} now leads the party",
  "{nick} quiere unirse a tu grupo": "{nick} wants to join your party",
  "{nick} se ha unido al grupo": "{nick} joined the party",
  "{nick} te invita a su grupo": "{nick} invites you to their party",
  "{nick} ya está en tu grupo": "{nick} is already in your party",
  "{n} en el grupo": "{n} in the party",
  "Jugando en {sala} · min {m}": "Playing in {sala} · min {m}",
  "En un grupo ({n}/{max})": "In a party ({n}/{max})",
  "Ahora te corean como {name}.": "The chants now go: {name}.",
  "Bien": "Good",
  "Contra el {rival} · Jornada {n}": "Against {rival} · Matchday {n}",
  "Cumplido": "Done",
  "Cómo te llevas": "How you get on",
  "En línea. Siempre.": "Online. Always.",
  "Encargo del míster": "Coach's orders",
  "Equipaciones y premios": "Kits and rewards",
  "Escribiendo…": "Typing…",
  "Fatal": "Awful",
  "Informe: {rival}": "Scouting: {rival}",
  "Juegan": "Style",
  "La Grada": "The Stands",
  "Lo que dice la afición": "What the fans are saying",
  "Los que te quieren ganar": "People who want to beat you",
  "Míster {coach}": "Coach {coach}",
  "Nombre en la camiseta": "Name on the shirt",
  "Noticias. Acierta alguna": "News. Gets one right now and then",
  "Ojo con": "Watch out for",
  "Para el próximo partido": "For the next match",
  "Puesto": "Position",
  "Rivales": "Rivals",
  "Sin cumplir": "Missed",
  "Sin partidos aún": "No matches yet",
  "Te adora": "Adores you",
  "Tenso": "Tense",
  "Tu agente. Cobra el 10 %": "Your agent. Takes 10 %",
  "Tu entrenador · {club}": "Your coach · {club}",
  "Vestuario · {club}": "Dressing room · {club}",
  "Volver a los chats": "Back to chats",
  "a favor": "for",
  "en contra": "against",
  "empate": "drawing",
  "ganando": "winning",
  "perdiendo": "losing",
  "{n} encajados": "{n} conceded",
  "Cuanto te trabaja: con él de tu lado creces más rápido.": "How much they work with you: with the coach on your side, you improve faster.",
  "Tus compañeros juegan mejor contigo cuanto mejor os lleváis.": "Your teammates play better with you the better you get along.",
  "La fama trae mejores ofertas al acabar la temporada.": "Fame brings better offers at the end of the season.",
  "Vestuario": "Dressing room",
  "Acierta el {n} % de tus pases": "Complete {n} % of your passes",
  "Da {n} asistencia": "Make {n} assist",
  "Deja la portería a cero": "Keep a clean sheet",
  "Encaja {n} gol como mucho": "Concede {n} goal at most",
  "Gana el partido": "Win the match",
  "Marca {n} gol": "Score {n} goal",
  "Recupera {n} balones": "Win the ball back {n} times",
  "Tira {n} veces": "Shoot {n} times",
  "Tu encargo para el partido: {objective}. Cúmplelo y lo notarás. Fállalo y también.": "Your orders for the match: {objective}. Do it and you'll feel it. Miss it and you'll feel that too.",
  "Encargo cumplido: {objective}. Lo apunto. Y tú apunta que lo he dicho.": "Orders done: {objective}. I'm writing it down. You write down that I said so.",
  "Encargo sin cumplir: {objective}. Tampoco era tan difícil. Bueno, sí. Pero no.": "Orders missed: {objective}. It wasn't that hard. Well, it was. But no.",
  "Encargo: ni lo intentaste. No estabas.": "Orders: you didn't even try. You weren't there.",
  "¿Me explicas qué ha pasado en el último partido?": "Want to explain what happened last match?",
  "La culpa es mía.": "It's on me.",
  "Por lo menos alguien lo dice. Mañana, doble sesión. Para ti, triple.": "At least someone says it. Tomorrow, double session. For you, triple.",
  "El árbitro no nos ha dejado.": "The ref wouldn't let us.",
  "El árbitro no ha fallado ese control. Tú sí.": "The ref didn't miss that first touch. You did.",
  "Pregúntale a la defensa.": "Ask the defenders.",
  "Se lo pregunto. Y de paso les enseño tu mensaje.": "I'll ask them. And show them your message while I'm at it.",
  "Entendido, míster.": "Understood, coach.",
  "Así me gusta. Obedecer también es un talento.": "That's what I like. Doing as you're told is a talent too.",
  "¿Y si juego a lo mío?": "What if I do my own thing?",
  "Juega a lo tuyo y luego se lo explicas al banquillo. Desde el banquillo.": "Do your own thing and then explain it to the bench. From the bench.",
  "Lo que haga falta por el equipo.": "Whatever the team needs.",
  "Eso díselo al utillero, que está sensible. Pero bien dicho.": "Tell that to the kit man, he's feeling fragile. But well said.",
  "{paper}: «¿Unas palabras antes del partido contra el {rival}?»": "{paper}: “A few words before the match against {rival}?”",
  "Máximo respeto al rival.": "Maximum respect to the opponent.",
  "{paper}: «Titular: \"Máximo respeto\". Nos hemos dormido escribiéndolo.»": "{paper}: “Headline: 'Maximum respect'. We fell asleep typing it.”",
  "Les vamos a pintar la cara.": "We're going to embarrass them.",
  "{paper}: «Portada. El {rival} ya la ha colgado en su vestuario.»": "{paper}: “Front page. {rival} have already pinned it up in their dressing room.”",
  "Hablaré en el campo.": "I'll do my talking on the pitch.",
  "{paper}: «{name} no habla. Su agente dice que cobra por palabra.»": "{paper}: “{name} isn't talking. Their agent says they charge by the word.”",
  "Soy {star}, del {rival}. El domingo te hago un túnel. Avisado quedas.": "It's {star}, from {rival}. Sunday I'm nutmegging you. Consider yourself warned.",
  "Tráete espinilleras.": "Bring shin pads.",
  "Me las traigo. De tu talla no las hacen.": "I'll bring them. They don't make them in your size.",
  "Suerte, crack.": "Good luck, champ.",
  "Qué educado. Así no se vende un partido.": "How polite. That's no way to sell a match.",
  "Cena de equipo el jueves en el bar de siempre. ¿Te apuntas? 🍖": "Team dinner Thursday at the usual bar. You in? 🍖",
  "Me apunto. El pan lo pago yo.": "I'm in. Bread's on me.",
  "Eso ha sonado a leyenda. Traigo el cántico.": "That sounded legendary. I'll bring the chant.",
  "Paso, el jueves toca descansar.": "I'll pass, Thursday is rest day.",
  "¿Míster? ¿Eres tú? Devuélvele el móvil.": "Coach? Is that you? Give them their phone back.",
  "Una marca de espinilleras quiere que salgas en un anuncio. Pagan en espinilleras. ¿Lo hacemos?": "A shin pad brand wants you in an ad. They pay in shin pads. Shall we?",
  "Hazlo. Quiero ser famoso.": "Do it. I want to be famous.",
  "Hecho. Sales tres segundos. Dos de espaldas.": "Done. You're on screen for three seconds. Two of them from behind.",
  "Primero el fútbol.": "Football first.",
  "Qué aburrido eres. Y qué rentable a largo plazo.": "How boring. And how profitable in the long run.",
  "Hijo, ¿comes bien? En la tele te veo más delgado.": "Love, are you eating properly? You look thinner on TV.",
  "Sí, mamá.": "Yes, Mum.",
  "Mentira. Te mando un táper. Y otro para tus compañeros, que los veo flojos.": "Liar. I'm sending you a lunchbox. And one for your teammates, they look weak.",
  "Mamá, es la cámara.": "Mum, it's the camera.",
  "La cámara no miente. Tu primo sí, pero la cámara no.": "The camera doesn't lie. Your cousin does, but the camera doesn't.",
  "¿Alguien sabe algo de {name}? El míster ha sacado a su sobrino.": "Anyone heard from {name}? The coach played his nephew.",
  "El sobrino ha dado un pase. Uno.": "The nephew completed a pass. One.",
  "Hat-trick de {name}. Voy a enmarcar el balón. Y luego a venderlo.": "Hat-trick from {name}. I'm framing the ball. Then selling it.",
  "MVP {name}. A partir de hoy las cañas las pagas tú.": "MVP {name}. From today, drinks are on you.",
  "{name} marcando y yo aplaudiendo. Reparto de papeles perfecto.": "{name} scoring and me clapping. Perfect division of labour.",
  "¡Victoria! Cena pagada por el que menos ha corrido: {lazy}.": "Win! Dinner paid by whoever ran the least: {lazy}.",
  "Un empate. Mi madre dice que es como perder, pero con educación.": "A draw. My mum says it's like losing, but polite.",
  "{n} goles. Me han metido {n} goles. Voy a cambiarme de número. Y de nombre.": "{n} goals. They put {n} past me. I'm changing my number. And my name.",
  "Tranquilo, {name}. Lo importante es que el bocadillo estaba bueno.": "Relax, {name}. The main thing is the sandwich was good.",
  "Nadie hable de esto. Nunca. Borrad el grupo.": "Nobody talks about this. Ever. Delete the group.",
  "Yo ya lo he borrado.": "Already deleted it.",
  "El míster ha dicho que mañana corremos. Gracias a todos.": "Coach says we're running tomorrow. Thanks, everyone.",
  "Esto es un equipo, señores.": "Now that's a team, people.",
  "Mañana nadie llega tarde. (Llegaré tarde.)": "Nobody's late tomorrow. (I'll be late.)",
  "Pido sitio en la foto.": "Saving my spot in the photo.",
  "Le dijiste que le pintabas la cara al {rival} y se la pintaste. LEYENDA.": "You said you'd embarrass {rival} and you did. LEGEND.",
  "Mucho hablar del {rival} y luego nada. Te lo vamos a recordar hasta en la boda.": "All that talk about {rival} and then nothing. We'll bring it up at your wedding.",
  "Tanto picar al {rival} para un empate. Menos Twitter y más gol.": "All that trash talk at {rival} for a draw. Less posting, more scoring.",
  "CONTROLES": "CONTROLS",
  "Arriba": "Up",
  "Abajo": "Down",
  "Izquierda": "Left",
  "Derecha": "Right",
  "Golpear": "Kick",
  "Regate · cuerpo · sprint": "Skill · body · sprint",
  "toque pasa, mantener dispara": "tap passes, hold shoots",
  "Pulsa…": "Press…",
  "principal": "main",
  "alternativa": "alternative",
  "Clic": "Click",
  "Sin tecla: {actions}": "No key: {actions}",
  "{key} ya es del juego (salir, estadísticas o chat). Elige otra.": "{key} is already taken by the game (leave, stats or chat). Pick another.",
  "Pulsa una casilla y luego la tecla. Supr la vacía, Esc cancela.": "Click a box, then press the key. Delete clears it, Esc cancels.",
  "Golpear con el ratón": "Kick with the mouse",
  "Clic izquierdo: golpeas hacia el cursor, al grado. El teclado sigue funcionando.": "Left click kicks toward the cursor, to the degree. The keyboard still works.",
  "Mando: stick o cruceta para moverte · A golpear · X regatear.": "Controller: stick or D-pad to move · A to kick · X for skills.",
  "Stick": "Stick",
  "golpear · mantén: tiro": "kick · hold: shot",
  "regate": "skill",
  "golpear hacia el ratón": "kick toward the mouse",
  "estadísticas": "stats",
  "Coloca el tiro": "Place your shot",
  "Justo después de chutar, mantén una dirección hacia un lado y el balón se dobla hacia allí.": "Right after shooting, hold a direction to one side and the ball bends that way.",
  "Correr": "Sprint",
  "Arrastra aquí para moverte": "Drag here to move",
  "Toca: pase · Mantén: tiro": "Tap: pass · Hold: shot",
  "…o toca el campo: el balón va ahí": "…or tap the pitch: the ball goes there",
  "Joystick: donde apoyes el pulgar": "Joystick: wherever your thumb lands",
  "TU MANDO": "YOUR CONTROLS",
  "Arrastra los botones a donde caiga tu pulgar.": "Drag the buttons to where your thumb falls.",
  "Tamaño": "Size",
  "Tocar el campo golpea hacia allí": "Tapping the pitch kicks there",
  "Vibración": "Vibration",
  "Zurdo (joystick a la derecha)": "Left-handed (joystick on the right)",
  "ámbar: toque pasa, mantener dispara": "amber: tap passes, hold shoots",
  "o toca el campo: el balón va ahí": "or tap the pitch: the ball goes there",
  "Justo después de chutar, lleva el joystick hacia un lado y el balón se dobla hacia allí.": "Right after shooting, push the joystick to one side and the ball bends that way.",
};
